<template>
  <v-layout row wrap class="mt-2 mb-2 mx-0" align-center>
    <v-flex xs12 offset-xs0 sm12 offset-sm0 md10 offset-md1 lg8 offset-lg2>
      <v-card outlined>
        <v-card-title class="font-weight-black text-h5 text-uppercase mb-1 py-2">
          {{season.title}}
        </v-card-title>
        <v-card-text :class="{ 'px-0': $vuetify.breakpoint.smAndDown }">
          <v-tabs color="blue" centered icons-and-text v-model="tab" :show-arrows="true">
            <v-tab href="#info">Prezentare<v-icon>mdi-information</v-icon>
            </v-tab>
            <v-tab href="#calendar">Calendar<v-icon>mdi-calendar</v-icon>
            </v-tab>
            <v-tab href="#standings">Clasament<v-icon>mdi-clipboard-list</v-icon>
            </v-tab>
            <v-tab href="#rules">Regulament<v-icon>mdi-file-document</v-icon>
            </v-tab>
            <v-tab href="#register">Înscrieri<v-icon>mdi-file-document-edit</v-icon>
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="tab" touchless>
            <v-tab-item value="info">
              <v-container fluid>
                <v-row class="mt-5" align="center" justify="center">
                  <v-col cols="12">
                      <v-progress-linear
                        color="light-green"
                        height="30"
                        :value="seasonElapsedPercent"
                        :buffer-value="seasonElapsedPercent"
                        class="mb-4"
                        stream
                      >
                        <span class="font-italic text--secondary font-weight-black" v-if="seasonElapsedPercent >= 100"><v-icon left small>mdi-trophy</v-icon>This one's done and dusted. Can we have one more, pretty please?<v-icon right small>mdi-trophy</v-icon></span>
                        <span class="font-italic text--secondary font-weight-black" v-else-if="seasonElapsedPercent > 0">Roughly {{Math.ceil(seasonElapsedPercent)}}% raced already!</span>
                        <span class="font-italic text--secondary font-weight-black" v-else><v-icon left small>mdi-penguin</v-icon>We can't wait to begin!<v-icon right small>mdi-penguin</v-icon></span>
                      </v-progress-linear>
                  </v-col>
                </v-row>
                <!--div v-html="season.longDescription">
                </div -->

                <!-- Incercam sa introducem aici posterul de sezon -->
                <v-row>
                  <!-- Image column -->
                  <v-col cols="12" md="4" class="d-flex justify-center">
                    <v-img
                      :src="`/img/${season.poster || 'rlr_logo.jpg'}`"
                      :height="$vuetify.breakpoint.smAndDown ? '600px' : '90%'"
                      contain
                      class="align-end"
                    ></v-img>
                  </v-col>
                  <!-- Text column -->
                  <v-col cols="12" md="8">
                    <div class="text-body-2 text-justify" v-if="season">
                      <span class="mt-4 font-weight-black text-h6 text-uppercase text--primary">Formatul competiției</span>
                      <p>
                        <strong>{{season.title}}</strong> constă în <strong>{{season.events.length}} etape</strong> care se desfășoară între
                        <strong>{{printDate ( seasonStartDate )}}</strong> și <strong>{{printDate ( seasonEndDate )}}</strong>.
                        <template v-if="season.rules.maxDriversPerCar > 1">
                          Aceasta este o competiție care pune accentul pe lucrul în echipă: fiecare echipaj este compus din
                            <template v-if="season.rules.minDriversPerCar != season.rules.maxDriversPerCar">{{season.rules.minDriversPerCar}} până la {{season.rules.maxDriversPerCar}} piloți
                            </template>
                            <template v-else>
                              {{season.rules.minDriversPerCar}} piloți
                            </template>
                          care se vor succede la comenzile mașinii în care participă.
                        </template>
                        <template v-else>
                          Aceasta este o competiție care pune accentul pe performanțele individuale ale piloților. 
                        </template>
                        Cluburile înregistrate pe platforma RLR au dreptul de a înscrie
                        <template v-if="season.rules.maxCarsPerTeam > 1">
                          cel mult {{season.rules.maxCarsPerTeam}} mașini în competiție, astfel că un număr maxim de {{season.rules.maxCarsPerTeam*season.rules.maxDriversPerCar}} piloți vor putea acumula puncte pentru clubul din care fac parte.
                        </template>
                        <template v-else>
                          o singură mașină în competiție, astfel că
                          <template v-if="season.rules.maxDriversPerCar > 1">
                            maxim {{season.rules.maxDriversPerCar}} piloți pot acumula puncte pentru clubul din care fac parte.
                          </template>
                          <template v-else>
                            doar un singur pilot poate acumula puncte pentru clubul din care face parte.
                          </template>
                        </template>
                      </p>
                      <span class="mt-4 font-weight-black text-h6 text-uppercase text--primary" v-if="season.rules.validCars.length > 1">Mașinile permise</span>
                      <span class="mt-4 font-weight-black text-h6 text-uppercase text--primary" v-else-if="season.rules.validCars.length">Mașina folosită</span>
                      <p>
                        <template v-if="season.rules.validCars.length > 1">
                          Poți alege ce mașină îți place în <strong>{{season.title}}</strong>. Te poți înscrie folosind oricare dintre următoarele modele:
                          <ul>
                            <li v-for="car in season.rules.validCars" :key="car._id">
                              {{car.title}}
                            </li>
                          </ul>
                        </template>
                        <template v-else-if="season.rules.validCars.length">
                          Toți participanții vor concura folosind mașini <strong>{{season.rules.validCars[0].title}}</strong>, așa că diferența o va face numai priceperea piloților!
                          Asigură-te că înțelegi complet mașina și îi descoperi toate secretele ca să ajungi la cel mai bun nivel.
                        </template>
                      </p>
                      <span class="mt-4 font-weight-black text-h6 text-uppercase text--primary">Participarea la curse</span>
                      <p>
                        Fiecare etapă are
                        <template v-if="maxRacesPerEvent != minRacesPerEvent">
                          între {{minRacesPerEvent}} și {{maxRacesPerEvent}} curse
                        </template>
                        <template v-else>
                          <template v-if="maxRacesPerEvent > 1">
                            {{maxRacesPerEvent}} curse
                          </template>
                          <template v-else>
                            o singură cursă
                          </template>
                        </template>
                        cu o durată
                        <template v-if="maxRaceLength != minRaceLength">
                          cuprinsă între {{minRaceLength}} minute și {{maxRaceLength}} minute.
                        </template>
                        <template v-else>
                          de {{maxRaceLength}} minute.
                        </template>
                        Toată lumea este binevenită în competiție,
                        <template v-if="season.rules.prequalEnabled">
                          dar va trebui să demonstreze în sesiunile de precalificare că este suficient de curat
                          <template v-if="season.rules.prequalLimitPercentage > 100">
                            și de rapid - la fiecare etapă vor putea participa doar piloții care au reușit să obțină un timp în precalificări care se află într-un <strong>barem de {{season.rules.prequalLimitPercentage}}%</strong> raportat la cel mai bun rezultat.
                          </template>
                          Mai multe detalii despre sesiunile și regulile de precalificare se pot găsi în pagina fiecărei etape.
                        </template>
                        <template v-else>
                          trebuie doar să fii înregistrat în sezon prin platformă și să confirmi prezența în săptămâna cursei, din pagina dedicată etapei.
                        </template>
                      </p>
                      <p>
                        La fiecare etapă
                        <template v-if="season.rules.maxSplits > 1">
                          se vor organiza maxim {{season.rules.maxSplits}} split-uri, în funcție de prezență.
                          Se vor organiza sesiuni de cursă pentru fiecare split cu cel puțin {{season.rules.minCarsPerSplit}} mașini prezente iar în fiecare split vor participa cel mult {{season.rules.maxCarsPerSplit}} de mașini.
                        </template>
                        <template v-else>
                          vor participa maxim {{season.rules.maxCarsPerSplit}} mașini, în prima divizie valorică.
                        </template>
                        <template v-if="season.rules.maxCarsInClassPerSplit">
                          Pe grila de start vor fi maxim {{season.rules.maxCarsInClassPerSplit}} mașini din aceeași clasă.
                        </template>
                      </p>
                      <template v-if="season.deadlines">
                        <span class="mt-4 font-weight-black text-h6 text-uppercase text--primary">Înscrieri</span>
                        <p>
                          <template v-if="Date.parse(season.deadlines.registration) < Date.now()">
                            Înscrierile pentru <strong>{{season.title}}</strong> s-au încheiat pe <strong>{{printDate(Date.parse(season.deadlines.registration))}}</strong>, dar te așteptăm în alte competiții.
                          </template>
                          <template v-else>
                            Înscrierile pentru <strong>{{season.title}}</strong> sunt deschise până pe <strong>{{printDate(Date.parse(season.deadlines.registration))}}</strong>, așa că hai și tu în competiție!
                          </template>
                        </p>
                        <span class="mt-4 font-weight-black text-h6 text-uppercase text--primary">Organizatori</span>
                        <p>
                          <template v-if="!season.organizatori || season.organizatori == ''">
                            Racing League Romania.
                          </template>
                          <template v-else>
                            <strong>{{season.organizatori}}</strong>
                          </template>
                        </p>
                        <span class="mt-4 font-weight-black text-h6 text-uppercase text--primary">Parteneri</span>
                        <p>
                          <template v-if="!season.parteneri || season.parteneri == '' ">
                            Voi.
                          </template>
                          <template v-else>
                            <strong>{{season.parteneri}}</strong>
                          </template>
                        </p>
                      </template>
                    </div>
                  </v-col>
                </v-row>
                <v-row v-if="isAdministrator" class="mt-4">
                  <v-col cols="12">
                    <v-card outlined>
                      <v-card-title
                        class="text-subtitle-1 font-weight-bold py-2"
                        style="cursor: pointer;"
                        @click="adminSectionExpanded.seasonAssets = !adminSectionExpanded.seasonAssets"
                      >
                        Cod sezon și pictograme mașini
                        <v-spacer></v-spacer>
                        <v-icon>{{adminSectionExpanded.seasonAssets ? 'mdi-chevron-up' : 'mdi-chevron-down'}}</v-icon>
                      </v-card-title>
                      <v-expand-transition>
                        <div v-show="adminSectionExpanded.seasonAssets">
                          <v-divider></v-divider>
                          <v-card-text>
                        <v-text-field
                          v-model.trim="seasonCode"
                          label="Cod sezon"
                          hint="Litere, cifre, underscore sau cratimă"
                          persistent-hint
                          :disabled="seasonCodeSaving"
                          :rules="[value => /^[A-Za-z0-9_-]+$/.test(value || '') || 'Codul poate conține doar litere, cifre, underscore și cratimă']"
                        ></v-text-field>
                        <div class="text-caption text--secondary mt-2">
                          Format fișiere: <strong>RLR_{{seasonCode || '&lt;cod&gt;'}}_&lt;număr&gt;.png</strong>.
                          Fișierul cu numărul <strong>00</strong> este imaginea implicită.
                        </div>
                          </v-card-text>
                          <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text :loading="seasonCodeSaving"
                          :disabled="!seasonCodeValid || seasonCode === savedSeasonCode"
                          @click="saveSeasonCode">Salvează codul</v-btn>
                          </v-card-actions>
                          <v-divider></v-divider>
                          <v-card-text>
                        <v-file-input
                          v-model="carIconFiles"
                          accept="image/png,.png"
                          label="Selectează pictogramele PNG"
                          prepend-icon="mdi-car-multiple"
                          multiple chips show-size
                          :disabled="carIconsUploading || seasonCode !== savedSeasonCode"
                          hint="Poți adăuga sau înlocui mai multe pictograme într-o singură încărcare."
                          persistent-hint
                        ></v-file-input>
                          </v-card-text>
                          <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" :loading="carIconsUploading"
                          :disabled="!carIconFiles || !carIconFiles.length || seasonCode !== savedSeasonCode"
                          @click="uploadCarIcons"><v-icon left>mdi-upload</v-icon>Încarcă pictogramele</v-btn>
                          </v-card-actions>
                        </div>
                      </v-expand-transition>
                    </v-card>
                  </v-col>
                  <v-col cols="12">
                    <v-card outlined>
                      <v-card-title
                        class="text-subtitle-1 font-weight-bold py-2"
                        style="cursor: pointer;"
                        @click="adminSectionExpanded.prequalDisplay = !adminSectionExpanded.prequalDisplay"
                      >
                        Setări de afișare precalificări
                        <v-spacer></v-spacer>
                        <v-icon>{{adminSectionExpanded.prequalDisplay ? 'mdi-chevron-up' : 'mdi-chevron-down'}}</v-icon>
                      </v-card-title>
                      <v-expand-transition>
                        <div v-show="adminSectionExpanded.prequalDisplay">
                          <v-divider></v-divider>
                          <v-card-text>
                        <v-select
                          v-model="prequalDriverSubtitle"
                          :items="prequalDriverSubtitleOptions"
                          label="Afișează sub numele pilotului"
                          :disabled="prequalDriverSubtitleSaving"
                          hide-details
                        ></v-select>
                          </v-card-text>
                          <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          text
                          :loading="prequalDriverSubtitleSaving"
                          :disabled="prequalDriverSubtitle === savedPrequalDriverSubtitle"
                          @click="savePrequalDriverSubtitle"
                        >Salvează</v-btn>
                          </v-card-actions>
                        </div>
                      </v-expand-transition>
                    </v-card>
                  </v-col>
                  <v-col cols="12">
                    <v-card outlined>
                      <v-card-title
                        class="text-subtitle-1 font-weight-bold py-2"
                        style="cursor: pointer;"
                        @click="adminSectionExpanded.licensePoints = !adminSectionExpanded.licensePoints"
                      >
                        Sistem puncte licență
                        <v-spacer></v-spacer>
                        <v-icon>{{adminSectionExpanded.licensePoints ? 'mdi-chevron-up' : 'mdi-chevron-down'}}</v-icon>
                      </v-card-title>
                      <v-expand-transition>
                        <div v-show="adminSectionExpanded.licensePoints">
                          <v-divider></v-divider>
                          <v-card-text>
                        <v-switch
                          v-model="licensePointSettings.enabled"
                          label="Folosește puncte de licență"
                        ></v-switch>
                        <template v-if="licensePointSettings.enabled">
                          <v-select
                            v-model="licensePointSettings.calculationStart.mode"
                            :items="licensePointStartOptions"
                            label="Calculează punctele"
                          ></v-select>
                          <v-select
                            v-if="licensePointSettings.calculationStart.mode === 'event'"
                            v-model="licensePointSettings.calculationStart.event"
                            :items="season.events"
                            item-text="title"
                            item-value="_id"
                            label="Începând cu etapa"
                          ></v-select>
                          <v-row>
                            <v-col cols="12" md="4">
                              <v-text-field v-model.number="licensePointSettings.penaltySecondsPerPoint" type="number" min="1" label="Secunde pentru 1 LP"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                              <v-text-field v-model.number="licensePointSettings.cleanRoundsRequired" type="number" min="1" label="Etape curate pentru recompensă"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                              <v-text-field v-model.number="licensePointSettings.cleanRoundsReward" type="number" min="0" label="LP scăzute ca recompensă"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12" md="4">
                              <v-text-field v-model.number="licensePointSettings.thresholds.qualifyingBan" type="number" min="0" label="Prag interdicție calificări"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                              <v-text-field v-model.number="licensePointSettings.thresholds.raceBan" type="number" min="0" label="Prag interdicție cursă"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                              <v-text-field v-model.number="licensePointSettings.thresholds.seasonElimination" type="number" min="0" label="Prag eliminare din sezon"></v-text-field>
                            </v-col>
                          </v-row>
                          <v-switch
                            v-model="licensePointSettings.carryOver.enabled"
                            label="Preia LP dintr-un sezon anterior"
                          ></v-switch>
                          <v-row v-if="licensePointSettings.carryOver.enabled">
                            <v-col cols="12" md="8">
                              <v-text-field v-model.trim="licensePointSettings.carryOver.sourceSeason" label="ID sezon anterior"></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4">
                              <v-text-field v-model.number="licensePointSettings.carryOver.percentage" type="number" min="0" max="100" suffix="%" label="Procent transferat"></v-text-field>
                            </v-col>
                          </v-row>
                        </template>
                          </v-card-text>
                          <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text :loading="licensePointSettingsSaving" @click="saveLicensePointSettings">Salvează</v-btn>
                          </v-card-actions>
                        </div>
                      </v-expand-transition>
                    </v-card>
                  </v-col>
                  <v-col cols="12">
                    <v-card outlined>
                      <v-card-title
                        class="text-subtitle-1 font-weight-bold py-2"
                        style="cursor: pointer;"
                        @click="adminSectionExpanded.rlrRating = !adminSectionExpanded.rlrRating"
                      >
                        RLR Rating
                        <v-spacer></v-spacer>
                        <v-icon>{{adminSectionExpanded.rlrRating ? 'mdi-chevron-up' : 'mdi-chevron-down'}}</v-icon>
                      </v-card-title>
                      <v-expand-transition>
                        <div v-show="adminSectionExpanded.rlrRating">
                          <v-divider></v-divider>
                          <v-card-text>
                        <v-switch
                          v-model="rlrRatingSettings.enabled"
                          label="Include sezonul în calculul RLR Rating"
                          :disabled="rlrRatingSettingsSaving"
                        ></v-switch>
                        <template v-if="rlrRatingSettings.enabled">
                          <v-select
                            v-model="rlrRatingSettings.roundSelection"
                            :items="rlrRatingRoundOptions"
                            label="Etape care influențează ratingul"
                            :disabled="rlrRatingSettingsSaving"
                          ></v-select>
                          <v-select
                            v-if="rlrRatingSettings.roundSelection === 'specific'"
                            v-model="rlrRatingSettings.rounds"
                            :items="season.events"
                            item-text="title"
                            item-value="_id"
                            label="Etape clasate"
                            multiple
                            chips
                            deletable-chips
                            :disabled="rlrRatingSettingsSaving"
                            :rules="[value => (value && value.length > 0) || 'Selectează cel puțin o etapă']"
                          ></v-select>
                        </template>
                        <v-alert :type="rlrRatingSettings.enabled ? 'info' : 'warning'" text dense class="mb-3">
                          {{ rlrRatingScopeSummary }}
                        </v-alert>
                        <v-alert v-if="rlrRatingRemovesHistory" type="warning" outlined dense class="mb-3">
                          Această modificare elimină rezultate clasate existente și va schimba retroactiv
                          ratingurile piloților.
                        </v-alert>
                        <v-card v-if="rlrRatingSimulator" outlined class="mb-3">
                          <v-card-text class="d-flex flex-column flex-sm-row align-sm-center">
                            <div>
                              <div class="text-caption text--secondary">
                                Politică RLR Rating — {{ rlrRatingSimulator.title }}
                              </div>
                              <strong>{{ rlrRatingPolicySummary }}</strong>
                              <div class="text-caption text--secondary">
                                Se aplică tuturor sezoanelor Ranked ale acestui simulator.
                              </div>
                            </div>
                            <v-spacer />
                            <v-btn
                              :to="rlrRatingDiagnosticsRoute"
                              text
                              color="primary"
                              class="align-self-start mt-2 mt-sm-0"
                            >
                              Gestionează în diagnostic
                              <v-icon right>mdi-open-in-new</v-icon>
                            </v-btn>
                          </v-card-text>
                        </v-card>
                        <div class="text-caption text--secondary">
                          Salvarea recalculează toate ratingurile simulatorului și poate dura câteva momente.
                        </div>
                          </v-card-text>
                          <v-card-actions>
                        <span v-if="rlrRatingSettingsDirty" class="text-caption warning--text ml-2">
                          Modificări nesalvate
                        </span>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="primary"
                          text
                          :loading="rlrRatingSettingsSaving"
                          :disabled="rlrRatingSettingsSaving || !rlrRatingSettingsValid || !rlrRatingSettingsDirty"
                          @click="saveRlrRatingSettings"
                        >Salvează și recalculează</v-btn>
                          </v-card-actions>
                        </div>
                      </v-expand-transition>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
            <v-tab-item value="calendar">
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" xl="4" v-for="(event, index) in season.events" :key="index">
                    <v-card outlined>
                      <v-img
                        :height="200"
                        lazy-src="@/assets/gchallenge.jpg"
                        :src="event.coverPhoto ? `/img/${event.coverPhoto}` : ''"
                        gradient="to top right, rgba(0,0,0,.2), rgba(0,0,0,.2)"
                      >
                        <div class="d-flex justify-space-between flex-wrap flex-column" :style="{'height': '100%'}">
                          <v-card-actions>
                            <v-chip
                              :color="new Date ( Date.parse ( event.time ) ) <= Date.now() ? 'yellow darken-2' : 'green darken-2'"
                              :dark="new Date ( Date.parse ( event.time ) ) > Date.now()"
                              label
                              :ripple="false"
                            >
                              <span class="text-overline">Etapa {{index+1}}</span>
                            </v-chip>
                          </v-card-actions>
                          <div class="pa-0 mt-0 d-flex flex-column">
                            <v-card-title class="text-h5 text-uppercase font-weight-bold white--text">{{event.title}}</v-card-title>
                            <v-btn text tile dark @click="revealSessions(index)" class="flex-grow-1 ma-0 py-5"><v-icon left small>mdi-timer</v-icon>Program</v-btn>
                          </div>
                        </div>
                      </v-img>
                      <v-container>
                        <v-row no-gutters>
                          <v-col cols="12">
                            <div outlined tile class="d-flex flex-wrap justify-space-between px-2 py-2">
                              <span class="text-caption"><v-icon class="mr-2">mdi-road-variant</v-icon>{{ event.track.trackFamily.name }} {{event.track.name}}</span>
                            </div>
                          </v-col>
                          <v-col cols="12">
                            <v-divider></v-divider>
                            <div outlined tile class="d-flex flex-wrap justify-space-between px-2 py-2">
                              <span class="text-caption"><v-icon class="mr-2">mdi-calendar</v-icon>{{ printDate ( new Date ( Date.parse ( event.time ) ) ) }}</span>
                            </div>
                          </v-col>
                        </v-row>
                      </v-container>
                      <v-card-actions class="pa-0 mt-0 d-flex">
                        <v-btn tile depressed text color="primary" :to="`/event/${event._id}?tab=info`" class="flex-grow-1 ma-0 py-5"><v-icon left>mdi-information</v-icon>Info</v-btn>
                        <v-btn tile depressed text color="green" dark :to="`/event/${event._id}?tab=results`" v-if="new Date ( Date.parse ( event.time ) ) <= Date.now()" class="flex-grow-1 ma-0 py-5"><v-icon left>mdi-clipboard-list</v-icon>Rezultate</v-btn>
                      </v-card-actions>
                      <v-expand-transition>
                        <v-card
                          v-if="sessionsRevealed==index"
                          class="transition-fast-in-fast-out v-card--reveal d-flex flex-column"
                          style="height: 100%;"
                        >
                          <v-card-title class="d-flex justify-space-between">
                            <span class="text-uppercase">Program</span>
                            <v-btn text @click="hideSessions()" color="red">Închide</v-btn>
                          </v-card-title>
                          <v-card-text style="overflow-y: auto">
                          <v-row no-gutters v-for="session in event.sessions" :key="session._id">
                            <template v-if="!session.official && session.type.code=='Q'">
                              <v-col cols="12">
                                <v-card-subtitle class="pa-0 mt-4 text-subtitle-2">{{printDate(new Date(Date.parse(session.startDate)))}} - {{printDate( new Date(session.startDate).getTime()+session.durationMinutes*60000)}}</v-card-subtitle>
                              </v-col>
                              <v-col cols="12">
                                <v-card outlined tile class="d-flex flex-wrap justify-space-between px-2 py-2">
                                  <span class="text-caption text-uppercase font-weight-medium">
                                    <v-icon small class="mr-2">mdi-timer</v-icon>
                                    <span>
                                      {{session.title}}
                                    </span>
                                  </span>
                                  <span v-if="session.hotstintLaps>1">
                                    Medie pe {{session.hotstintLaps}} tururi
                                  </span>
                                </v-card>
                              </v-col>
                            </template>
                          </v-row>
                          <v-row no-gutters>
                            <v-card-subtitle class="pa-0 mt-4 text-subtitle-2">{{ printDate ( new Date ( Date.parse ( event.time ) ) ) }}</v-card-subtitle>
                          </v-row>
                          <v-row no-gutters>
                            <v-col cols="12" v-for="session in event.sessions" :key="session._id">
                              <v-card outlined tile class="d-flex flex-wrap justify-space-between px-2 py-2" v-if="session.official || session.type.code!='Q'">
                                <span class="text-caption text-uppercase font-weight-medium">
                                  <v-icon small class="mr-2" v-if="session.type.code=='Q' && session.official">mdi-timer</v-icon>
                                  <v-icon small class="mr-2" v-else-if="session.type.code=='R'">mdi-flag-checkered</v-icon>
                                  <v-icon small class="mr-2" v-else-if="session.type.code=='A'">mdi-human-male-board</v-icon>
                                  <v-icon small class="mr-2" v-else>mdi-flag-outline</v-icon>
                                  <span>
                                    <span>{{session.title}}</span><span v-if="session.official"> ({{session.durationMinutes}}min)</span>
                                  </span>
                                </span>
                                <span>
                                  <span v-if="session.official">
                                   {{printTime(session.startDate)}}
                                  </span>
                                  <span v-else>
                                    {{printTime(session.startDate)}}
                                  </span>
                                </span>
                              </v-card>
                            </v-col>
                          </v-row>
                          </v-card-text>
                        </v-card>
                      </v-expand-transition>
                    </v-card>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
            <v-tab-item value="standings">
              <v-container fluid class="pt-0">
                  <v-row align="center" no-gutters>
                    <v-col
                      cols="12"
                      align="center"
                      class="pa-0"
                    >
                      <v-dialog
                        v-model="newStandingsDialog"
                        max-width="600"
                        scrollable
                        persistent
                      >
                        <v-card>
                          <v-card-title>Creează clasament nou</v-card-title>
                          <v-card-text>
                            <v-form>
                              <v-row>
                                <v-col cols="12"><v-checkbox v-model="newStandings.public" label="Afișează public?" @change="unsavedChanges=true"></v-checkbox></v-col>
                                <v-col cols="6">
                                  <v-text-field :rules="[rules.required]" label="Nume" v-model="newStandings.title" @change="unsavedChanges=true"></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                  <v-select
                                    :rules="[rules.required]"
                                    :items="availableStandingsTypes"
                                    return-object
                                    item-value="_id"
                                    item-text="name"
                                    label="Tip clasament"
                                    v-model="newStandings.type"
                                  ></v-select>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="4">
                                  <v-select
                                    v-if="season.carClasses"
                                    multiple
                                    :items="season.carClasses.map(cls => cls.obj)"
                                    item-text="name"
                                    item-value="_id"
                                    label="Clase acceptate"
                                    v-model="newStandings.filters.carClasses"
                                  ></v-select>
                                </v-col>
                                <v-col cols="4">
                                  <v-select
                                    v-if="season.driverClasses"
                                    multiple
                                    :items="season.driverClasses.map(cls => cls.obj)"
                                    item-text="name"
                                    item-value="_id"
                                    label="Licențe acceptate"
                                    v-model="newStandings.filters.driverClasses"
                                  ></v-select>
                                </v-col>
                                <v-col cols="4">
                                  <v-select
                                    v-if="season.rules.validCars"
                                    multiple
                                    :items="season.rules.validCars"
                                    item-text="title"
                                    item-value="_id"
                                    return-object
                                    label="Mașini acceptate"
                                    v-model="newStandings.filters.carModels"
                                  ></v-select>
                                </v-col>
                                <v-col cols="12">
                                  <v-slider
                                    v-model="newStandings.filters.maxIgnoredEvents"
                                    label="Etape ignorate"
                                    step="1"
                                    ticks="always"
                                    tick-size="5"
                                    color="red"
                                    track-color="green"
                                    thumb-label="always"
                                    thumb-size="24"
                                    thumb-color="red"
                                    :max="season.events.length-1"
                                    :min="0"
                                  ></v-slider>
                                </v-col>
                              </v-row>
                              <v-row no-gutters>
                                <v-col cols="12"><span class="text-subtitle-2">Coloane afișate</span></v-col>
                                <v-col cols="12" sm="6" md="3"><v-checkbox v-model="newStandings.displayedColumns" label="Poziție" value="position" disabled></v-checkbox></v-col>
                                <v-col cols="12" sm="6" md="3"><v-checkbox v-model="newStandings.displayedColumns" label="Mașină" value="cars" @change="unsavedChanges=true"></v-checkbox></v-col>
                                <v-col cols="12" sm="6" md="3"><v-checkbox v-model="newStandings.displayedColumns" label="Livery" value="livery" @change="unsavedChanges=true"></v-checkbox></v-col>
                                <v-col cols="12" sm="6" md="3"><v-checkbox v-model="newStandings.displayedColumns" label="Piloți" value="drivers" @change="unsavedChanges=true"></v-checkbox></v-col>
                                <v-col cols="12" sm="6" md="3"><v-checkbox v-model="newStandings.displayedColumns" label="Club" value="teams" @change="unsavedChanges=true"></v-checkbox></v-col>
                                <v-col cols="12" sm="6" md="3"><v-checkbox v-model="newStandings.displayedColumns" label="Puncte" value="points" @change="unsavedChanges=true"></v-checkbox></v-col>
                                <v-col cols="12" sm="6" md="3"><v-checkbox v-model="newStandings.showAttendance" label="Prezență" @change="unsavedChanges=true"></v-checkbox></v-col>
                                <v-col cols="12" sm="6" md="6">
                                  <v-row no-gutters align="center">
                                    <v-checkbox hide-details v-model="newStandings.displayedColumns" value="miscText" @change="unsavedChanges=true" class="shrink mr-2 mt-0">
                                    </v-checkbox>
                                    <v-text-field label="Coloană extra" v-model="newStandings.miscTextName" @change="unsavedChanges=true"></v-text-field>
                                  </v-row>
                                </v-col>
                              </v-row>
                            </v-form>
                          </v-card-text>
                          <v-card-actions>
                            <v-btn
                              @click="addNewStandings()"
                              color="green"
                              dark
                              :disabled="!newStandings.title || !newStandings.type || !newStandings.type._id"
                            ><v-icon small>mdi-plus</v-icon>Creează</v-btn>
                            <v-btn @click="newStandingsDialog=false" color="red" text>Anulează</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <v-dialog
                        v-model="editStandingsEventsDialog"
                        max-width="600"
                        scrollable
                        v-if="currentStandings"
                        persistent
                      >
                        <v-card>
                          <v-card-title>Curse punctate</v-card-title>
                          <v-card-text>
                            <v-menu
                              :close-on-content-click="true"
                              v-model="standingsAddNewEventMenu"
                              @click:outside="standingsAddNewEventMenu=false"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                  text
                                  color="primary"
                                  :disabled="!currentStandingsAvailableEvents.length"
                                  v-bind="attrs"
                                  v-on="on"
                                  :offset-x="true"
                                >
                                  <v-icon left>mdi-plus</v-icon>Adaugă etape
                                </v-btn>
                              </template>
                              <v-card max-width="600px">
                                <v-card-title>Etape disponibile</v-card-title>
                                <v-card-subtitle>{{season.title}}</v-card-subtitle>
                                <v-card-text>
                                  <v-list
                                    style="max-height: 300px"
                                    class="overflow-y-auto"
                                    dense
                                  >
                                    <v-list-item
                                      v-for="(event, eventIndex) in currentStandingsAvailableEvents"
                                      :key="eventIndex"
                                    >
                                      <v-list-item-action>
                                        <v-btn color="green" dark min-width="36px" class="px-0"><v-icon class="mx-0" @click="addCurrentStandingsEvent(event)">mdi-plus</v-icon></v-btn>
                                      </v-list-item-action>
                                      <v-list-item-content>
                                        {{event.title}}
                                      </v-list-item-content>
                                    </v-list-item>
                                  </v-list>
                                </v-card-text>
                              </v-card>
                            </v-menu>
                            
                            <v-divider></v-divider>
                            <v-card outlined v-for="(event, eventIndex) in currentStandings.events" :key="event.obj._id" class="mt-2">
                              <v-card-title>{{event.obj.title}}</v-card-title>
                              <v-card-text>
                                <v-list>
                                  <v-list-item :key="sessionListIndex" v-for="(session, sessionListIndex) in event.sessions">
                                    <v-row align="center">
                                      <v-col>{{session.obj.title}}</v-col>
                                      <v-col>
                                        <v-select
                                          :items="availableScoringTypes"
                                          v-model="currentStandings.events[eventIndex].sessions[sessionListIndex].scoringType"
                                          return-object
                                          item-value="_id"
                                          item-text="name"
                                          label="Grilă punctare"
                                        ></v-select>
                                      </v-col>
                                      <v-list-item-action>
                                        <v-btn
                                          color="red"
                                          text
                                          min-width="36px"
                                          class="px-0"
                                        >
                                          <v-icon class="mx-0" @click="removeCurrentStandingsEventSession(eventIndex, sessionListIndex)" left>
                                            mdi-delete-empty
                                          </v-icon>
                                        </v-btn>
                                      </v-list-item-action>
                                    </v-row>
                                  </v-list-item>
                                  <v-list-item>
                                    <v-row align="center">
                                      <v-col>
                                        <v-select
                                          :items="availableSessionsFromEvent(event.obj)"
                                          return-object
                                          item-value="_id"
                                          item-text="title"
                                          v-model="event.pendingSession"
                                          label="Sesiunea"
                                        ></v-select>
                                      </v-col>
                                      <v-col>
                                        <v-select
                                          :items="availableScoringTypes"
                                          return-object
                                          item-value="_id"
                                          item-text="name"
                                          v-model="event.pendingScoringType"
                                          label="Grilă punctare"
                                        ></v-select>
                                      </v-col>
                                      <v-list-item-action>
                                        <v-btn
                                          color="green"
                                          text
                                          min-width="36px"
                                          class="px-0"
                                          :disabled="!event.pendingSession || !event.pendingSession._id
                                            || !event.pendingScoringType || !event.pendingScoringType._id"
                                        >
                                          <v-icon class="mx-0" @click="addCurrentStandingsEventSession(eventIndex)" left>
                                            mdi-check-bold
                                          </v-icon>
                                        </v-btn>
                                      </v-list-item-action>
                                    </v-row>
                                  </v-list-item>
                                </v-list>
                              </v-card-text>
                            </v-card>
                          </v-card-text>
                          <v-card-actions>
                            <v-btn
                              @click="saveCurrentStandingsEvents()"
                              color="green"
                              dark
                              :loading="standingsCalculationLoading"
                            >Salvează</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <v-dialog
                        v-model="editStandingsDialog"
                        max-width="600"
                        persistent
                        scrollable
                        v-if="currentStandings"
                      >
                        <v-card>
                          <v-card-title>Editează clasament {{currentStandings.title}}</v-card-title>
                          <v-card-text>
                            <v-form>
                              <v-row>
                                <v-col cols="12" sm="6"><v-checkbox v-model="currentStandings.public" label="Afișează public?" @change="unsavedChanges=true"></v-checkbox></v-col>
                                <v-col cols="12" sm="6"><v-checkbox v-model="currentStandings.official" label="Clasament oficial?" @change="unsavedChanges=true"></v-checkbox></v-col>
                                <v-col cols="6">
                                  <v-text-field :rules="[rules.required]" label="Nume" v-model="currentStandings.title"></v-text-field>
                                </v-col>
                                <v-col cols="6">
                                  <v-select
                                    :rules="[rules.required]"
                                    :items="availableStandingsTypes"
                                    return-object
                                    item-value="_id"
                                    item-text="name"
                                    label="Tip clasament"
                                    v-model="currentStandings.type"
                                  ></v-select>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="4">
                                  <v-select
                                    v-if="season.carClasses"
                                    multiple
                                    :items="season.carClasses.map(cls => cls.obj)"
                                    item-text="name"
                                    item-value="_id"
                                    label="Clase acceptate"
                                    v-model="currentStandings.filters.carClasses"
                                  ></v-select>
                                </v-col>
                                <v-col cols="4">
                                  <v-select
                                    v-if="season.driverClasses"
                                    multiple
                                    :items="season.driverClasses.map(cls => cls.obj)"
                                    item-text="name"
                                    item-value="_id"
                                    label="Licențe acceptate"
                                    v-model="currentStandings.filters.driverClasses"
                                  ></v-select>
                                </v-col>
                                <v-col cols="4">
                                  <v-select
                                    v-if="season.rules.validCars"
                                    multiple
                                    :items="season.rules.validCars"
                                    item-text="title"
                                    item-value="_id"
                                    return-object
                                    label="Mașini acceptate"
                                    v-model="currentStandings.filters.carModels"
                                  ></v-select>
                                </v-col>
                                <v-col cols="12">
                                  <v-slider
                                    v-model="currentStandings.filters.maxIgnoredEvents"
                                    label="Etape ignorate"
                                    step="1"
                                    ticks="always"
                                    tick-size="5"
                                    color="red"
                                    track-color="green"
                                    thumb-label="always"
                                    thumb-size="24"
                                    thumb-color="red"
                                    :max="season.events.length-1"
                                    :min="0"
                                  ></v-slider>
                                </v-col>
                              </v-row>
                              <v-row no-gutters>
                                <v-col cols="12"><span class="text-subtitle-2">Coloane afișate</span></v-col>
                                <v-col cols="12" sm="6" md="3"><v-checkbox v-model="currentStandings.displayedColumns" label="Poziție" value="position" disabled></v-checkbox></v-col>
                                <v-col cols="12" sm="6" md="3"><v-checkbox v-model="currentStandings.displayedColumns" label="Mașină" value="cars" @change="unsavedChanges=true"></v-checkbox></v-col>
                                <v-col cols="12" sm="6" md="3"><v-checkbox v-model="currentStandings.displayedColumns" label="Livery" value="livery" @change="unsavedChanges=true"></v-checkbox></v-col>
                                <v-col cols="12" sm="6" md="3"><v-checkbox v-model="currentStandings.displayedColumns" label="Piloți" value="drivers" @change="unsavedChanges=true"></v-checkbox></v-col>
                                <v-col cols="12" sm="6" md="3"><v-checkbox v-model="currentStandings.displayedColumns" label="Club" value="teams" @change="unsavedChanges=true"></v-checkbox></v-col>
                                <v-col cols="12" sm="6" md="3"><v-checkbox v-model="currentStandings.displayedColumns" label="Puncte" value="points" @change="unsavedChanges=true"></v-checkbox></v-col>
                                <v-col cols="12" sm="6" md="3"><v-checkbox v-model="currentStandings.showAttendance" label="Prezență" @change="unsavedChanges=true"></v-checkbox></v-col>
                                <v-col cols="12" sm="6" md="6">
                                  <v-row no-gutters align="center">
                                    <v-checkbox hide-details v-model="currentStandings.displayedColumns" value="miscText" @change="unsavedChanges=true" class="shrink mr-2 mt-0"></v-checkbox>
                                    <v-text-field label="Coloană extra" v-model="currentStandings.miscTextName"></v-text-field>
                                </v-row>
                              </v-col>
                              </v-row>
                            </v-form>
                          </v-card-text>
                          <v-card-actions>
                            <v-btn
                              @click="saveCurrentStandingsDetails()"
                              color="green"
                              dark
                              :loading="standingsCalculationLoading"
                            >Salvează</v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-col>
                  </v-row>
                  <v-row align="center" no-gutters class="mt-3">
                    <v-spacer></v-spacer>
                    <v-col
                      cols="12"
                      xl="6"
                      lg="6"
                      md="8"
                      sm="12"
                      align="center"
                    >
                      <v-slide-group
                        center-active
                        mandatory
                        v-model="selectedStandings"
                        @change="selectStandings($event)"
                        show-arrows="always"
                      >
                        <v-slide-item
                          v-for="standings in availableStandings"
                          :key="standings._id"
                          :value="standings._id"
                          v-slot="{active, toggle}"
                        >
                          <v-btn
                            :input-value="active"
                            active-class="primary white--text"
                            depressed
                            tile
                            @click="toggle"
                            class="mx-1"
                          >
                            <v-icon
                              v-if="standings.official"
                              small
                              left
                              title="Clasament oficial"
                              aria-label="Clasament oficial"
                            >mdi-check-decagram</v-icon>{{standings.title.toUpperCase()}}<span
                              v-if="standings.filters && standings.filters.maxIgnoredEvents > 0"
                              class="standings-drop-rounds-cue ml-1"
                              :title="standings.filters.maxIgnoredEvents === 1 ? '1 etapă ignorată' : `${standings.filters.maxIgnoredEvents} etape ignorate`"
                              :aria-label="standings.filters.maxIgnoredEvents === 1 ? '1 etapă ignorată' : `${standings.filters.maxIgnoredEvents} etape ignorate`"
                            >(-{{standings.filters.maxIgnoredEvents}})</span>
                          </v-btn>
                        </v-slide-item>
                      </v-slide-group>
                    </v-col>
                    <v-spacer></v-spacer>
                  </v-row>
                  <v-row align="center" no-gutters v-if="canUserEditStandings">
                    <v-col cols="12" class="standings-admin-toolbar">
                        <v-btn
                          @click="deleteCurrentStandings()"
                          text
                          v-if="currentStandings && currentStandings._id"
                          color="red"
                        >
                          <v-icon color="red">mdi-delete-empty</v-icon>Șterge
                        </v-btn>
                        <v-btn
                          @click="newStandingsDialog=true"
                          text
                          color="green"
                        >
                          <v-icon color="green" left>mdi-plus</v-icon>Adaugă
                        </v-btn>
                      <template v-if="currentStandings">
                        <v-switch label="Editează tabel" v-model="editEnabled" color="green" hide-details class="standings-edit-switch ma-0 mx-2"></v-switch>
                        <v-btn tile text color="primary" dark @click="editStandingsDialog=true"><v-icon left>mdi-pencil</v-icon>Detalii</v-btn>
                        <v-btn tile text color="primary" dark @click="editStandingsEventsDialog=true"><v-icon left>mdi-calendar</v-icon>Etape</v-btn>
                        <v-btn tile text color="primary" dark @click="recalculateCurrentStandings()" :loading="standingsCalculationLoading"><v-icon left>mdi-refresh</v-icon>Recal</v-btn>
                        <v-btn tile text color="green" v-if="unsavedChanges" dark @click="saveStandings()" :loading="standingsSaveLoading"><v-icon left>mdi-content-save</v-icon>Salvează</v-btn>
                      </template>
                    </v-col>
                  </v-row>
                <v-row>
                  <v-col cols="12" v-if="currentStandings">
                    <v-data-table
                      :headers="standingsTableHeader.filter(h => h.value === 'attendance'
                        ? currentStandings.showAttendance !== false
                        : editEnabled
                        || currentStandings.displayedColumns.includes(h.value))"
                      :items="currentStandings.entries.filter(e => editEnabled || !e.disqualified)"
                      disable-pagination
                      hide-default-footer
                    >
                      <template v-slot:header.miscText>
                        {{currentStandings.miscTextName}}
                      </template>

                      <template v-slot:header.attendance>
                        Prezență [{{currentStandings.events.length}}]
                      </template>

                      <template v-slot:header.cars v-if="currentStandings.type.code == 'T'">
                        Echipă
                      </template>

                      <template v-slot:header.cars v-else>
                        Mașină
                      </template>
                      
                      <template v-slot:[`item.position`]="{ item }" v-if="editEnabled">
                        <v-switch
                          v-model="item.disqualified"
                          :false-value="true"
                          :true-value="false"
                          :value="item.disqualified"
                          :label="item.position.toString()"
                          @change="unsavedChanges=true"
                        ></v-switch>
                      </template>
                      <template v-slot:[`item.position`]="{ item }" v-else>
                        <div class="standings-position">
                          <span>{{item.position}}</span>
                          <v-tooltip top>
                            <template v-slot:activator="{on, attrs}">
                              <span
                                class="standings-evolution"
                                :class="`standings-evolution--${item.positionEvolution.status}`"
                                v-bind="attrs"
                                v-on="on"
                                :aria-label="positionEvolutionText(item.positionEvolution)"
                              >
                                <span
                                  v-if="item.positionEvolution.status === 'up'"
                                  class="standings-evolution-arrow standings-evolution-arrow--up"
                                ></span>
                                <span v-if="['up', 'down'].includes(item.positionEvolution.status)">
                                  {{item.positionEvolution.places}}
                                </span>
                                <span
                                  v-if="item.positionEvolution.status === 'down'"
                                  class="standings-evolution-arrow standings-evolution-arrow--down"
                                ></span>
                                <span v-if="item.positionEvolution.status === 'new'" class="standings-evolution-new">NOU</span>
                                <span v-if="['none', 'same'].includes(item.positionEvolution.status)" class="standings-evolution-neutral">—</span>
                              </span>
                            </template>
                            <span>{{positionEvolutionText(item.positionEvolution)}}</span>
                          </v-tooltip>
                        </div>
                      </template>
                      
                      <template v-slot:[`item.teams`]="{ item }" v-if="editEnabled">
                        <template v-for="(team, index) in item.teams">
                          <v-checkbox
                            v-model="team.ignored"
                            :label="`${team.name}`"
                            :key="index"
                            @change="unsavedChanges=true"
                            :true-value="false"
                            :false-value="true"
                            :disabled="item.teams.filter(t=>!t.ignored).length < 2 && !team.ignored"
                          ></v-checkbox>
                        </template>
                      </template>
                      <template v-slot:[`item.teams`]="{ item }" v-else>
                        <template v-for="team in item.teams">
                          <span :key="team._id" v-if="!team.ignored">
                            {{team.name}}
                          </span>
                        </template>
                      </template>
                      
                      <template v-slot:[`item.drivers`]="{ item }" v-if="editEnabled">
                        <template v-for="(driver, index) in item.drivers">
                          <v-checkbox
                            v-model="driver.ignored"
                            :label="`${driver.profile.firstName} ${driver.profile.lastName}`"
                            :key="index"
                            @change="unsavedChanges=true"
                            :true-value="false"
                            :false-value="true"
                            :disabled="item.drivers.filter(d=>!d.ignored).length < 2 && !driver.ignored"
                          ></v-checkbox>
                        </template>
                      </template>
                      <template v-slot:[`item.drivers`]="{ item }" v-else>
                        <template v-for="driver in item.drivers">
                          <span :key="driver._id" v-if="driver.ignored !== true" class="my-1 d-flex align-center">
                            <kbd 
                              v-for="(driverClass, kindex) in getUserClasses(driver._id)"
                              :key="kindex"
                              class="mr-1 driver-class"
                              :style="{
                                backgroundColor: driverClass.backgroundColor || '#424242',
                                color: driverClass.textColor || '#ffffff'
                              }"
                            >
                              {{driverClass.acronym}}
                            </kbd>
                            <router-link
                              v-if="isLoggedIn"
                              class="driver-profile-link"
                              :to="`/driver-profile/${driver._id}`"
                              :title="`Vezi profilul lui ${driver.profile.firstName} ${driver.profile.lastName}`"
                              :aria-label="`Vezi profilul lui ${driver.profile.firstName} ${driver.profile.lastName}`"
                            >{{driver.profile.firstName}} {{driver.profile.lastName}}<v-icon x-small>mdi-account-circle-outline</v-icon></router-link>
                            <template v-else>
                              {{driver.profile.firstName}} {{driver.profile.lastName}}
                            </template>
                          </span>
                        </template>
                      </template>
                      
                      <template v-slot:[`item.cars`]="{ item }" v-if="editEnabled">
                        <template v-for="(car, index) in item.cars">
                          <v-checkbox
                            v-model="car.ignored"
                            :label="`#${car.raceNumber} ${car.carName}`"
                            :key="index"
                            @change="unsavedChanges=true"
                            :true-value="false"
                            :false-value="true"
                            :disabled="item.cars.filter(c=>!c.ignored).length < 2 && !car.ignored"
                          ></v-checkbox>
                        </template>
                      </template>
                      <template v-slot:[`item.cars`]="{ item }" v-else>
                        <template v-for="(car, index) in item.cars.filter(c=>!c.ignored)">
                          <span :key="car._id" v-if="currentStandings.type.code != 'T'" class="my-1 d-block">
                            <kbd 
                              v-for="(carClass, kindex) in car.classes" 
                              :key="kindex"
                              class="mr-1 driver-class"
                              :style="{
                                backgroundColor: carClass.backgroundColor || '#424242',
                                color: carClass.textColor || '#ffffff'
                              }"                        
                            >
                              {{carClass.acronym}}
                            </kbd>
                            #{{car.raceNumber}} {{car.carName}}
                          </span>
                          <span v-else-if="index == 0" :key="car._id">
                            {{car.carName}}
                          </span>
                        </template>
                      </template>
                      
                      <template v-slot:[`item.livery`]="{ item }">
                        <template v-for="(car, index) in item.cars.filter(c=>!c.ignored)">
                          <span :id="`car-${index}`" :key="car._id" v-if="currentStandings.type.code != 'T'" class="my-1 d-block">
                            <v-img 
                              v-if="carHasLiveryPreview(car.raceNumber)"
                              :src="carLiveryPreviewURL(car.raceNumber)"
                              @error="handleCarLiveryError(car.raceNumber)"
                              max-width="100"
                              max-height="40"
                            />
                          </span>
                        </template>
                      </template>
                      
                      <template v-slot:[`item.compensationPoints`]="props" v-if="editEnabled">
                        <v-edit-dialog
                          :return-value.sync="props.item.compensationPoints"
                          persistent
                          large
                        >
                          {{props.item.compensationPoints}}p
                          <template v-slot:input>
                            <v-text-field
                              v-model="props.item.compensationPoints"
                              :rules="[rules.numberRequired]"
                              label="Compensare"
                              autofocus
                              type="number"
                              @change="unsavedChanges=true"
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </template>
                      <template v-slot:[`item.compensationPoints`]="{item}" v-else>
                        {{item.compensationPoints}}p
                      </template>
                      
                      <template v-slot:[`item.points`]="{item}" v-if="editEnabled">
                        {{item.points}}+{{item.compensationPoints}}={{parseFloat(item.points)+parseFloat(item.compensationPoints)}}p
                      </template>
                      <template v-slot:[`item.points`]="{item}" v-else>
                        <v-tooltip left>
                          <template v-slot:activator="{on, attrs}">
                            <span v-on="on" v-bind="attrs">
                              {{parseFloat(item.points)+parseFloat(item.compensationPoints)}}p
                            </span>
                          </template>
                          <div v-for="event in item.scoredEvents" :key="event.event_id" :class="event.ignored ? 'red--text' : 'green--text'">
                            {{event.points}}p {{event.event.title}}
                          </div>
                          <div>
                            {{parseFloat(item.compensationPoints)}}p ajustare
                          </div>
                        </v-tooltip>
                      </template>

                      <template v-slot:[`item.attendance`]="{item}">
                        <div class="standings-attendance">
                          <v-tooltip
                            top
                            v-for="round in currentStandings.events"
                            :key="round.obj._id"
                          >
                            <template v-slot:activator="{on, attrs}">
                              <span
                                class="standings-attendance-round"
                                v-bind="attrs"
                                v-on="on"
                                :aria-label="`${round.obj.title}: ${scoredEventForRound(item, round).present ? 'prezent' : 'absent'}`"
                              >
                                <span class="standings-attendance-status">
                                  <v-icon
                                    small
                                    :color="scoredEventForRound(item, round).present ? 'green' : 'red'"
                                  >{{scoredEventForRound(item, round).present ? 'mdi-check-circle' : 'mdi-close-circle'}}</v-icon>
                                </span>
                                <span
                                  class="standings-attendance-points"
                                  :class="{'standings-attendance-points--ignored': scoredEventForRound(item, round).ignored}"
                                >{{scoredEventForRound(item, round).points}}p</span>
                              </span>
                            </template>
                            <span>
                              {{round.obj.title}}: {{scoredEventForRound(item, round).present ? 'prezent' : 'absent'}},
                              {{scoredEventForRound(item, round).points}} puncte<span v-if="scoredEventForRound(item, round).ignored"> (ignorate)</span>
                            </span>
                          </v-tooltip>
                        </div>
                      </template>
                      
                      <template v-slot:[`item.miscText`]="props" v-if="editEnabled">
                        <v-edit-dialog
                          :return-value.sync="props.item.miscText"
                          persistent
                          large
                        >
                          {{props.item.miscText}}
                          <template v-slot:input>
                            <v-text-field
                              v-model="props.item.miscText"
                              :rules="[rules.required]"
                              :label="currentStandings.miscTextName"
                              autofocus
                              @change="unsavedChanges=true"
                            ></v-text-field>
                          </template>
                        </v-edit-dialog>
                      </template>
                      <template v-slot:[`item.miscText`]="{item}" v-else>
                        {{item.miscText}}
                      </template>
                    </v-data-table>
                  </v-col>
                  <v-col cols="12" v-else-if="!availableStandings.length" align="center">
                    <span class="text-h4">Clasamentul va fi disponibil în curând.</span>
                  </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
            <v-tab-item value="rules">
              <v-row>
                <v-col xs6 sm6 md6 lg6>
                  <v-btn icon title="Pagina anterioară" aria-label="Pagina anterioară" :disabled="pdfRulebookPage == 1" @click="pdfRulebookPage--">
                    <v-icon>mdi-chevron-left</v-icon>
                  </v-btn>
                </v-col>
                <v-col xs6 sm6 md6 lg6>
                  <v-btn icon title="Pagina următoare" aria-label="Pagina următoare" class="float-right" :disabled="pdfRulebookPage == rulebookPageCount" @click="pdfRulebookPage++"><v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-container fluid class="py-0">
                <pdf
                  class="rulebook-pdf"
                  :style="rulebookPdfStyle"
                  @num-pages="updateRuleBookPageCount"
                  @page-size="updateRuleBookPageSize"
                  :page="pdfRulebookPage"
                  :src="`/${season.pdfRulebookPath}`"
                ></pdf>
              </v-container>
              <v-row>
                <v-col xs6 sm6 md6 lg6>
                  <v-btn icon title="Pagina anterioară" aria-label="Pagina anterioară" :disabled="pdfRulebookPage == 1" @click="pdfRulebookPage--">
                    <v-icon>mdi-chevron-left</v-icon>
                  </v-btn>
                </v-col>
                <v-col xs6 sm6 md6 lg6>
                  <v-btn icon title="Pagina următoare" aria-label="Pagina următoare" class="float-right" :disabled="pdfRulebookPage == rulebookPageCount" @click="pdfRulebookPage++"><v-icon>mdi-chevron-right</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-tab-item>

            <v-tab-item value="register">
              <v-container v-if="!isLoggedIn" fluid>
                <v-row>
                  <v-col>
                    <p class="text-h6 font-weight-light">Pentru a te inscrie intr-un sezon trebuie <router-link
                        to="/login">sa fii autentificat</router-link>
                    </p>
                  </v-col>
                </v-row>
              </v-container>
              <v-container v-else fluid>
                <v-form ref="form">
                <v-row>
                  <v-col>
                    <v-subheader class="text-h6 font-weight-light">
                      Alte cluburi în care ești pilot
                    </v-subheader>

                    <span v-if="carsUserDriving.length < 1" class="pl-4 subtitle-1">Nu ești înregistrat ca pilot în
                      alt club.</span>

                    <v-list>
                      <template v-for="(car, index) in carsUserDriving">
                        <v-list-item :key="car._id">

                          <v-list-item-action>
                            <v-btn disabled outlined depressed fab class="ml-2" color="blue">
                              <v-icon>mdi-file-document-edit-outline</v-icon>
                            </v-btn>
                          </v-list-item-action>

                          <v-list-item-content>
                            <v-list-item-title>
                              <v-icon class="mr-3">mdi-car</v-icon>{{ "#" + car.raceNumber + " " + car.carName }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              <v-icon class="mr-3">mdi-racing-helmet</v-icon>
                              <span :key="driver._id" :id="`driver-${car.raceNumber}-${driver._id}`"
                                :style="{color: driver.registrationStatus ? 'green' : 'red'}"
                                text
                                v-for="(driver, dIndex) in car.drivers"
                              >
                                {{driver.driverName}}{{dIndex != car.drivers.length - 1 ? ', ' : ''}}
                              </span>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider v-if="index < userTeamRegistrations.length - 1" :key="index" :inset="inset">
                        </v-divider>
                      </template>
                    </v-list>

                    <v-subheader class="text-h6 font-weight-light">
                      Cluburile tale înregistrate
                    </v-subheader>

                    <span v-if="userTeamRegistrations.length < 1" class="pl-4 subtitle-1">Nu a fost inregistrat niciun
                      club pe care îl coordonezi</span>

                    <v-list>
                      <template v-for="(registration, index) in userTeamRegistrations">
                        <v-list-item :key="registration._id">
                          <v-list-item-action>
                            <v-btn outlined depressed fab class="ml-2" color="blue"
                              :to="`/season-registration/${season._id}/${registration._id}`">
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </v-list-item-action>

                          <v-list-item-content>
                            <v-list-item-title>
                              <v-icon class="mr-3">mdi-account-group</v-icon>{{ registration.teamName }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              <template v-for="car in registration.cars">
                                <div :key="car._id">
                                  <v-icon class="mr-3">mdi-car</v-icon>
                                  #{{car.raceNumber}} {{car.carName}}
                                  <span
                                    v-if="car.drivers.reduce ( (a, c) => { return a && c.registrationStatus }, true )">(Echipaj
                                    confirmat:
                                    {{car.drivers.map ( driver => {return driver.driverName} ).join (', ')}})</span>
                                  <span v-else>(Echipaj neconfirmat:
                                    <span :key="driver._id" :id="`driver-${car.raceNumber}-${driver._id}`"
                                      :style="{color: driver.registrationStatus ? 'green' : 'red'}"
                                      text
                                      v-for="(driver, dIndex) in car.drivers"
                                    >
                                      {{driver.driverName}}{{dIndex != car.drivers.length - 1 ? ', ' : ''}}
                                    </span>
                                    )
                                  </span>
                                </div>
                              </template>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider v-if="index < userTeamRegistrations.length - 1" :key="index" :inset="inset">
                        </v-divider>
                      </template>
                    </v-list>

                    <v-row>
                      <v-col>
                        <v-btn
                          :disabled="!registrationsOpen"
                          @click="openRegistration()"
                          :to="`/season-registration/${season._id}`"
                        >
                          <v-icon>mdi-plus</v-icon> Înscrie un club
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                </v-form>
              </v-container>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<style>
.entry-content {
  font-size: 14px;
  line-height: 22px;
  text-align: left;
}
.img-responsive {
  width: 100%;
}
.wp-block-image {
  margin-right: 44px;;
}
.v-slide-group__prev {
  display: none !important;
}
</style>
<script>
  import {
    mapActions,
    mapState,
    mapGetters
  } from 'vuex'
  import pdf from 'vue-pdf'
  import axios from '@/plugins/axios';

  export default {
    components: {
      pdf
    },
    data: () => {
      return {
        registrationHasError: true,
        currentRegistration: {
          team: '',
          cars: []
        },
        inset: true,
        items: [{
            action: 'mdi-label',
            title: 'signups',
            divider: true
          },
          {
            action: 'mdi-label',
            title: 'duration',
            divider: true
          }
        ],
        dialogOpen: false,
        events: [{
            name: 'Monaco',
            start: '2020-12-6 20:00',
            end: '2020-12-6 22:00',
            color: 'red',
          },
          {
            name: 'Monza',
            start: '2020-12-13 20:00',
            end: '2020-12-13 22:00',
            color: 'red',
          },
          {
            name: 'Brands Hatch',
            start: '2020-12-20 20:00',
            end: '2020-12-20 22:00',
            color: 'red',
          },
          {
            name: 'Kyalami',
            start: '2020-12-27 20:00',
            end: '2020-12-27 22:00',
            color: 'red',
          },
        ],
        standings: [],
        focus: '',
        type: 'month',
        typeToLabel: {
          month: 'Month',
          week: 'Week',
          day: 'Day',
          '4day': '4 Days',
        },
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,
        colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
        names: ['Meeting', 'Holiday', 'PTO', 'Travel', 'Event', 'Birthday', 'Conference', 'Party'],
        userTeamRegistrations: [],
        userAvailableTeams: [],
        carsUserDriving: [],
        wantsToRegister: false,
        selectedCarClass: {},
        driverMenu: false,
        driverClassMenu: false,
        pdfRulebookPage: 1,
        rulebookPageCount: 0,
        pdfRulebookAspectRatio: null,
        sessionsRevealed: -1,
        standingsTableHeader: [
          { text: "#", value: "position", sortable: false, align: 'center' },
          { text: "Mașină", value: "cars", sortable: false },
          { text: "Livery", value: "livery", sortable: false },
          { text: "Piloți", value: "drivers", sortable: false },
          { text: "Club", value: "teams", sortable: false },
          { text: "Compensare", value: "compensationPoints", sortable: false },
          { text: "Puncte", value: "points", sortable: false },
          { text: "Prezență", value: "attendance", sortable: false },
          { text: "Info", value: "miscText", sortable: false }
        ],
        selectedStandings: undefined,
        currentStandings: {
          title: '',
          type: { code: 'D' },
          miscTextName: '',
          entries: [],
          displayedColumns: [],
          showAttendance: true,
          events: [],
          public: false,
          official: false,
          filters: {
            carClasses: [],
            driverClasses: []
          }
        },
        newStandings: {
          title: '',
          type: { code: 'D' },
          miscTextName: '',
          entries: [],
          displayedColumns: [],
          showAttendance: true,
          events: [],
          public: false,
          official: false,
          filters: {
            carClasses: [],
            driverClasses: [],
            carModels: [],
            maxIgnoredEvents: 0
          }
        },
        standingsHashmap: {},
        newStandingsDialog: false,
        editStandingsDialog: false,
        editStandingsEventsDialog: false,
        rules: {
          required: value => !!value || 'Obligatoriu',
          numberRequired: value => value !== undefined || 'Obligatoriu',
          timePenaltyRange: value => (value >= 0 && value <= 300) || 'Între 0 și 300 de secunde.',
          lapPenaltyRange: value => (value >= 0 && value <= 100) || 'Între 0 și 100 de tururi.',
          gridPenaltyRange: value => (value >= 0 && value <= 20) || 'Între 0 și 20 de poziții.'
        },
        emptyStandings: {
          title: '',
          type: {code: 'D'},
          displayedColumns: ['position', 'points'],
          showAttendance: true,
          miscTextName: '',
          entries: [],
          public: false,
          official: false,
          filters: {
            carClasses: [],
            driverClasses: [],
            carModels: [],
            maxIgnoredEvents: 0
          }
        },
        editEnabled: false,
        unsavedChanges: false,
        availableStandingsEvents: [],
        availableScoringTypes: [],
        availableStandingsTypes: [],
        standingsReady: false,
        standingsCalculationLoading: false,
        standingsSaveLoading: false,
        standingsAddNewEventMenu: false,
        adminSectionExpanded: {
          seasonAssets: false,
          prequalDisplay: false,
          licensePoints: false,
          rlrRating: false
        },
        seasonCode: '',
        savedSeasonCode: '',
        seasonCodeSaving: false,
        carIconFiles: [],
        carIconsUploading: false,
        carLiveryFallbacks: {},
        carLiveryHidden: {},
        prequalDriverSubtitle: 'club',
        savedPrequalDriverSubtitle: 'club',
        prequalDriverSubtitleSaving: false,
        prequalDriverSubtitleOptions: [
          { text: 'Club', value: 'club' },
          { text: 'Echipă', value: 'team' }
        ],
        licensePointSettingsSaving: false,
        licensePointStartOptions: [
          {text: 'De la începutul sezonului', value: 'seasonStart'},
          {text: 'De la o etapă selectată', value: 'event'}
        ],
        licensePointSettings: {
          enabled: false,
          calculationStart: {mode: 'seasonStart', event: null},
          penaltySecondsPerPoint: 5,
          cleanRoundsRequired: 2,
          cleanRoundsReward: 3,
          thresholds: {qualifyingBan: 17, raceBan: 25, seasonElimination: 35},
          carryOver: {enabled: false, sourceSeason: null, percentage: 25}
        },
        rlrRatingSettingsSaving: false,
        rlrRatingRoundOptions: [
          {text: 'Toate etapele', value: 'all'},
          {text: 'Doar etapele selectate', value: 'specific'}
        ],
        rlrRatingSettings: {
          enabled: false,
          roundSelection: 'all',
          rounds: []
        },
        savedRlrRatingSettings: {
          enabled: false,
          roundSelection: 'all',
          rounds: []
        }
      }
    },
    methods: {
      consoleLog(obj) {
        console.log(obj);
      },
      ...mapActions("user", ["getUserPermissions", "getUserRoles"]),
      resetCarLiveryState () {
        this.carLiveryFallbacks = {};
        this.carLiveryHidden = {};
      },
      serializedRlrRatingSettings (settings) {
        const supplied = settings || {};
        return JSON.stringify({
          enabled: supplied.enabled === true,
          roundSelection: supplied.roundSelection === 'specific' ? 'specific' : 'all',
          rounds: (supplied.rounds || []).map(round => round._id || round).sort()
        });
      },
      async saveSeasonCode () {
        if (!this.seasonCodeValid) return;
        this.seasonCodeSaving = true;
        try {
          const response = await axios({
            url: `/api/season/${this.season._id}/code`,
            method: 'POST',
            data: {code: this.seasonCode}
          });
          this.savedSeasonCode = response.data.data.code;
          this.seasonCode = response.data.data.code;
          this.season.code = response.data.data.code;
          this.season.carIconsVersion = response.data.data.carIconsVersion;
          this.resetCarLiveryState();
          this.showSnackbar({timeout: 5000, content: 'Codul sezonului a fost salvat. Pictogramele existente au fost redenumite.', color: 'success', value: true});
        } catch (error) {
          this.seasonCode = this.savedSeasonCode;
          this.showSnackbar({timeout: 7000, content: 'Codul sezonului nu a putut fi salvat. Verifică dacă este valid și unic.', color: 'error', value: true});
        } finally {
          this.seasonCodeSaving = false;
        }
      },
      async uploadCarIcons () {
        if (!this.carIconFiles || !this.carIconFiles.length || this.seasonCode !== this.savedSeasonCode) return;
        this.carIconsUploading = true;
        try {
          const formData = new FormData();
          this.carIconFiles.forEach(file => formData.append('files', file));
          const response = await axios.post(
            `/api/season/${this.season._id}/car-icons`,
            formData,
            {headers: {'Content-Type': 'multipart/form-data'}}
          );
          this.season.carIconsVersion = response.data.data.carIconsVersion;
          this.carIconFiles = [];
          this.resetCarLiveryState();
          this.showSnackbar({
            timeout: 5000,
            content: `${response.data.data.files.length} pictograme au fost încărcate.`,
            color: 'success',
            value: true
          });
        } catch (error) {
          this.showSnackbar({
            timeout: 8000,
            content: `Pictogramele nu au fost încărcate. Folosește formatul RLR_${this.savedSeasonCode}_<număr>.png.`,
            color: 'error',
            value: true
          });
        } finally {
          this.carIconsUploading = false;
        }
      },
      async savePrequalDriverSubtitle () {
        this.prequalDriverSubtitleSaving = true;

        try {
          let response = await axios({
            url: `/api/season/${this.season._id}/prequal-driver-subtitle`,
            method: 'POST',
            data: {
              prequalDriverSubtitle: this.prequalDriverSubtitle
            }
          });

          this.savedPrequalDriverSubtitle = response.data.data.prequalDriverSubtitle;
          this.season.prequalDriverSubtitle = response.data.data.prequalDriverSubtitle;
          this.showSnackbar({
            timeout: 4000,
            content: 'Setarea pentru precalificări a fost salvată.',
            color: 'success',
            value: true
          });
        } catch (error) {
          this.prequalDriverSubtitle = this.savedPrequalDriverSubtitle;
          this.showSnackbar({
            timeout: 7000,
            content: 'Setarea pentru precalificări nu a putut fi salvată.',
            color: 'error',
            value: true
          });
        } finally {
          this.prequalDriverSubtitleSaving = false;
        }
      },
      async saveLicensePointSettings () {
        this.licensePointSettingsSaving = true;
        try {
          const response = await axios({
            url: `/api/season/${this.season._id}/license-points-settings`,
            method: 'POST',
            data: this.licensePointSettings
          });
          this.licensePointSettings = JSON.parse(JSON.stringify(response.data.data.licensePoints));
          this.season.rules.licensePoints = JSON.parse(JSON.stringify(this.licensePointSettings));
          this.showSnackbar({timeout: 4000, content: 'Setările punctelor de licență au fost salvate.', color: 'success', value: true});
        } catch (error) {
          this.showSnackbar({timeout: 7000, content: 'Setările punctelor de licență nu au putut fi salvate.', color: 'error', value: true});
        } finally {
          this.licensePointSettingsSaving = false;
        }
      },
      async saveRlrRatingSettings () {
        if (this.rlrRatingSettingsSaving || !this.rlrRatingSettingsValid || !this.rlrRatingSettingsDirty) return;
        this.rlrRatingSettingsSaving = true;
        try {
          const response = await axios({
            url: `/api/season/${this.season._id}/rlr-rating-settings`,
            method: 'POST',
            data: this.rlrRatingSettings
          });
          this.rlrRatingSettings = JSON.parse(JSON.stringify(response.data.data.rlrRating));
          this.savedRlrRatingSettings = JSON.parse(JSON.stringify(this.rlrRatingSettings));
          this.season.rules.rlrRating = JSON.parse(JSON.stringify(this.rlrRatingSettings));
          const rebuild = response.data.data.rebuild;
          const content = rebuild
            ? `Setările au fost salvate. ${rebuild.drivers} piloți și ${rebuild.changes} modificări de rating au fost recalculate.`
            : 'Setările RLR Rating au fost salvate.';
          this.showSnackbar({timeout: 7000, content, color: 'success', value: true});
        } catch (error) {
          const message = error.response && error.response.data && error.response.data.error;
          this.showSnackbar({timeout: 7000, content: message || 'Setările RLR Rating nu au putut fi salvate.', color: 'error', value: true});
        } finally {
          this.rlrRatingSettingsSaving = false;
        }
      },
      selectStandings(standingsId, updateRoute = true) {
        const standings = this.availableStandings.find(item => item._id == standingsId)
          || (this.availableStandings.length ? this.availableStandings[0] : null);
        const selectedStandingsId = standings ? standings._id : '';

        this.selectedStandings = selectedStandingsId;
        this.currentStandings = standings;

        if (updateRoute && this.$route.query.activeStandings != selectedStandingsId) {
          this.$router.replace({
            query: {
              ...this.$route.query,
              activeStandings: selectedStandingsId
            }
          });
        }
      },
      availableSessionsFromEvent(event) {
        let ev = this.availableStandingsEvents.find(e => e._id==event._id);

        if (!ev) {
          return [];
        }
        
        return ev.sessions;
      },
      resetStandingsEventSelection(event) {
        this.$set(event, 'pendingSession', {});
        this.$set(event, 'pendingScoringType', {});
      },
      addCurrentStandingsEvent (event) {
        let alreadyRegistered = this.currentStandings.events.filter(event => event.obj._id==event._id).length > 0;
        
        if ( !alreadyRegistered ) {
          this.currentStandings.events.push({
            obj: event,
            sessions: [],
            pendingSession: {},
            pendingScoringType: {}
          });
          this.unsavedChanges = true;
        }
      },
      removeCurrentStandingsEvent(eventIndex) {
        this.currentStandings.events.splice(eventIndex, 1);
        this.unsavedChanges = true;
      },
      addCurrentStandingsEventSession(eventIndex) {
        let ev = this.currentStandings.events[eventIndex]
        if (!ev.pendingSession || !ev.pendingSession._id
          || !ev.pendingScoringType || !ev.pendingScoringType._id) {
          return;
        }

        const sessionAlreadyRegistered = ev.sessions.some(session => {
          return session.obj._id == ev.pendingSession._id
            && session.scoringType._id == ev.pendingScoringType._id;
        });

        if (sessionAlreadyRegistered) {
          this.showSnackbar({
            timeout: 7000,
            content: 'Sesiunea are deja această grilă de punctaj în etapă.',
            color: 'error',
            value: true
          });
          return;
        }

        ev.sessions.push({
          obj: ev.pendingSession,
          scoringType: ev.pendingScoringType
        });
        this.resetStandingsEventSelection(ev);
        this.unsavedChanges = true;
      },
      removeCurrentStandingsEventSession(eventIndex, sessionIndex) {
        this.currentStandings.events[eventIndex].sessions.splice(sessionIndex, 1);
        this.unsavedChanges = true;
      },
    getUserClasses(driverId) {      
      if (this.userSeasonClasses) {
        return this.userSeasonClasses.filter(item => item.user == driverId).map(uc=>uc.classes).flat();
      }

      return [];
    },
    printCountry (countryCode) {
      try {
        return this.countries[countryCode].name;
      } catch {
        return '';
      }
    },
    printRegion (countryCode, regionCode) {
      try {
        return this.countries[countryCode].regions[regionCode].name;
      } catch {
        return '';
      }
    },
    printLocation (countryCode, regionCode) {
      let country = this.printCountry (countryCode);
      let region = this.printRegion (countryCode, regionCode);
      
      let text = country;
      
      if ( text != '' && region != '' ) {
        text += ', ';
      }
      
      text += region;
      
      return text;
    },
    showDriverMenu () {
      this.driverMenu = true;
    },
    closeDriverMenu () {
      this.driverMenu = false;
    },
    getFullDriverName (carIndex, driverId) {
      if (!this.currentRegistration.cars[carIndex].availableDrivers) {
        return '';
      }
      
      let driver = this.currentRegistration.cars[carIndex].availableDrivers.find(d => d._id == driverId);
      
      if (!driver) {
        return '';
      }
      
      return driver.profile.firstName + " " + driver.profile.lastName;
    },
      viewDay({
        date
      }) {
        this.focus = date
        this.type = 'day'
      },
      getEventColor(event) {
        return event.color
      },
      setToday() {
        this.focus = ''
      },
      prev() {
        this.$refs.calendar.prev()
      },
      next() {
        this.$refs.calendar.next()
      },
      showEvent({
        nativeEvent,
        event
      }) {
        const open = () => {
          this.selectedEvent = event
          this.selectedElement = nativeEvent.target
          setTimeout(() => {
            this.selectedOpen = true
          }, 10)
        }

        if (this.selectedOpen) {
          this.selectedOpen = false
          setTimeout(open, 10)
        } else {
          open()
        }

        nativeEvent.stopPropagation()
      },

      rnd(a, b) {
        return Math.floor((b - a + 1) * Math.random()) + a
      },
      getEvents() {
        this.$http.get('/api/events').then(events => {
          this.events = events.map(event => {
            let eventDuration = event.practice + event.qualify + event.race + (event.raceInverted ? event.race :
              0);
            let eventEnd = event.date + eventDuration;
            return {
              name: event.title,
              start: event.date,
              end: eventEnd,
              color: 'red',
            }
          })
        })
      },
      addCurrentRegistrationCar() {
        if (this.currentRegistration.cars.length < this.season.rules.maxCarsPerTeam) {
          let newCar = {
            carModel: '',
            carName: '',
            raceNumber: '',
            drivers: [],
            team: ''
          }
          newCar.availableDrivers = this.driversList.filter((availableDriver) => {
            let available = true

            this.currentRegistration.cars.forEach(otherCar => {
              if (otherCar.drivers.indexOf(availableDriver._id) >= 0) {
                available = false;
              }

            })
            return available;
          })

          newCar.availableDrivers = newCar.availableDrivers.map(d => ({...d, classes: []}))
          this.currentRegistration.cars.push(newCar)
        }
      },
      syncErrors(errorValue) {
        this.registrationHasError = errorValue
      },
      ...mapActions('season', [
        'getSeason',
        'getUserSeasonClasses',
        'getSeasonStandings'
      ]),
      ...mapActions('app', ['showSnackbar']),
      printDate(date) {
        const monthNames = ["Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie",
          "Iulie", "August", "Septembrie", "Octombrie", "Noiembrie", "Decembrie"
        ];
        
        let m = new Date(date);
        
        let result = ("00" + m.getUTCDate()).slice(-2) + " " + monthNames[m.getUTCMonth()] + " " + m.getUTCFullYear();

        return result;
      },
      printShortDate(date) {
        let m = new Date(date);
        
        let result = ("00" + m.getUTCDate()).slice(-2) + "." + ("00" + (m.getUTCMonth()+1)).slice(-2);

        return result;
      },
      printTime(date) {
        let m = new Date(date)
        
        let result = ("00" + m.getHours()).slice(-2) + ":" + ("00" + m.getMinutes()).slice(-2)

        return result;
      },
      setUserRegisteredTeams() {
        this.userTeamRegistrations = []
        const userId = this.userinfo && (this.userinfo.id || this.userinfo._id);

        if (!userId) {
          return;
        }

        (this.season.registrations || []).filter(Boolean).forEach(registration => {
          const team = registration.team;
          const userManagesTeam = team && (team.managers || []).some(manager => {
            const managerId = manager && manager._id ? manager._id : manager;
            return managerId == userId;
          });
          const teamOwnerId = team && team.owner && team.owner._id ? team.owner._id : team && team.owner;

          if (registration.initiatedByUser == userId
            || userManagesTeam
            || teamOwnerId == userId) {
            this.userTeamRegistrations.push(registration)
          }
        })
      },
      setCarsUserDriving() {
        let cars = []
        const userId = this.userinfo && (this.userinfo.id || this.userinfo._id);

        if (!userId) {
          this.carsUserDriving = cars;
          return;
        }

        (this.season.registrations || []).filter(Boolean).forEach(registration => {
          (registration.cars || []).filter(Boolean).forEach(car => {
            if ((car.drivers || []).filter(Boolean).some(driver => {
                const driverId = driver.driver && driver.driver._id ? driver.driver._id : driver.driver;
                return driverId == userId;
              })) {
              cars.push(car)
            }
          })
        })

        this.carsUserDriving = cars
      },
      openRegistration() {
        this.wantsToRegister = true
      },
      closeRegistration() {
        this.wantsToRegister = false
      },
      pilotsRules(input) {
        let pilotiPerMasina = this.season.rules.maxDriversPerCar == this.season.rules.minDriversPerCar ?
          this.season.rules.maxDriversPerCar :
          `${this.season.rules.maxDriversPerCar} pana la ${this.season.rules.maxDriversPerCar}`
        return (input.length <= this.season.rules.maxDriversPerCar && input.length >= this.season.rules
            .minDriversPerCar) ||
          `Selecteaza ${pilotiPerMasina} piloti`
      },
      updateRuleBookPageCount(e) {
        this.rulebookPageCount = e
      },
      updateRuleBookPageSize(width, height) {
        if (width > 0 && height > 0) {
          this.pdfRulebookAspectRatio = width / height
        }
      },
      carNumberRules (input) {        
        return ( input && !isNaN (input) && !isNaN (parseFloat(input)) ) || 'Alege un număr pentru mașină'
      },
      carNameRules ( input ) {
        return ( input.length > 0 && input.trim().length > 0 ) || 'Alege numele echipajului'
      },
      domDecoder (str) {
        let parser = new DOMParser();
        let dom = parser.parseFromString('<!doctype html><body>' + str, 'text/html');
        return dom.body.textContent;
      },
      
      decoder (str) {
        var textArea = document.createElement('textarea');
        textArea.innerHTML = str;
        return textArea.value;
      },
      scoredEventForRound (entry, round) {
        const roundId = round.obj && round.obj._id ? round.obj._id : round.obj;
        const scoredEvent = entry.scoredEvents.find(event => {
          const eventId = event.event && event.event._id ? event.event._id : event.event;
          return eventId.toString() === roundId.toString();
        });

        return scoredEvent || {
          points: 0,
          present: false,
          ignored: false
        };
      },
      positionEvolutionText (evolution) {
        if (evolution.status === 'up') {
          return `A urcat ${evolution.places} ${evolution.places === 1 ? 'poziție' : 'poziții'} față de etapa precedentă`;
        }

        if (evolution.status === 'down') {
          return `A coborât ${evolution.places} ${evolution.places === 1 ? 'poziție' : 'poziții'} față de etapa precedentă`;
        }

        if (evolution.status === 'new') {
          return 'Prima apariție în clasament';
        }

        if (evolution.status === 'same') {
          return 'Poziție neschimbată față de etapa precedentă';
        }

        return 'Evoluția va fi disponibilă după etapa a doua';
      },
      revealSessions(eventIndex) {
        this.sessionsRevealed = eventIndex;
      },
      hideSessions() {
        this.sessionsRevealed = -1;
      },
      async getAvailableStandingsEvents() {
        let response = await axios.get(`/api/standings/${this.season._id}/available-events`);
        this.availableStandingsEvents = response.data.data;
      },
      async getAvailableScoringTypes() {
        let response = await axios.get(`/api/standings/scoring-types`);
        this.availableScoringTypes = response.data.data;
      },
      async getAvailableStandingsTypes() {
        let response = await axios.get(`/api/standings/standings-types`);
        this.availableStandingsTypes = response.data.data;
      },
      addNewStandings() {
        if (!this.newStandings.title || !this.newStandings.type || !this.newStandings.type._id) {
          return;
        }

        let s = {
          _id: (Math.random() + 1).toString(36).substring(7),
          events: [],
          entries: [],
          filters: {
            carClasses: this.newStandings.filters.carClasses,
            driverClasses: this.newStandings.filters.driverClasses,
            carModels: this.newStandings.filters.carModels,
            maxIgnoredEvents: this.newStandings.filters.maxIgnoredEvents
          },
          displayedColumns: this.newStandings.displayedColumns,
          showAttendance: this.newStandings.showAttendance,
          miscTextName: this.newStandings.miscTextName,
          title: this.newStandings.title,
          type: this.newStandings.type,
          public: this.newStandings.public,
          official: false,
        }
        
        this.newStandings = JSON.parse(JSON.stringify(this.emptyStandings));
        
        this.season.standings.push(s);
        // Update session hashmap
        this.season.standings.forEach ( standings => {
          this.standingsHashmap[standings._id] = standings
        })
        
        this.selectStandings(s._id);
        this.newStandingsDialog = false;
        this.unsavedChanges = true;
      },
      deleteCurrentStandings() {
        let standingsIndex = this.season.standings.findIndex(s => s._id == this.currentStandings._id);
        
        if ( standingsIndex != -1 ) {
          this.season.standings.splice(standingsIndex, 1);
        }
        
        if ( this.season.standings.length ) {
          this.selectStandings(this.season.standings[0]._id || '');
        } else {
          this.selectStandings('');
        }

        this.unsavedChanges = true;
        
      },
      async refreshCurrentStandingsEntries() {
        let response = await axios.post (
          `/api/standings/${this.season._id}/entries`,
          this.currentStandings
        )
        
        this.currentStandings.entries = response.data.data;
        
        this.unsavedChanges = true;
      },
      async recalculateCurrentStandings() {
        this.standingsCalculationLoading = true;
        try {
          await this.refreshCurrentStandingsEntries();
        } catch (error) {
          this.showSnackbar({
            timeout: 10000,
            content: 'Clasamentul nu a putut fi recalculat. Datele existente nu au fost modificate.',
            color: 'error',
            value: true
          });
        } finally {
          this.standingsCalculationLoading = false;
        }
      },
      async saveCurrentStandingsEvents() {
        const invalidEvents = this.currentStandings.events.some(event => {
          return !Array.isArray(event.sessions) || !event.sessions.length || event.sessions.some(session => {
            return !session.obj || !session.obj._id || !session.scoringType || !session.scoringType._id;
          });
        });

        if (invalidEvents) {
          this.showSnackbar({
            timeout: 10000,
            content: 'Fiecare etapă trebuie să conțină cel puțin o sesiune și o grilă de punctaj.',
            color: 'error',
            value: true
          });
          return;
        }

        this.standingsCalculationLoading = true;
        try {
          await this.refreshCurrentStandingsEntries();
          this.editStandingsEventsDialog = false;
        } catch (error) {
          this.showSnackbar({
            timeout: 10000,
            content: 'Etapele nu au putut fi calculate. Clasamentul anterior a fost păstrat.',
            color: 'error',
            value: true
          });
        } finally {
          this.standingsCalculationLoading = false;
        }
      },
      async saveCurrentStandingsDetails() {
        this.standingsCalculationLoading = true;
        try {
          await this.saveEditCurrentStandings();
        } catch (error) {
          this.showSnackbar({
            timeout: 10000,
            content: 'Detaliile nu au putut fi aplicate. Clasamentul anterior a fost păstrat.',
            color: 'error',
            value: true
          });
        } finally {
          this.standingsCalculationLoading = false;
        }
      },
      async saveEditCurrentStandings() {
        if (!this.currentStandings) {
          return;
        }

        /*
        this.season.standings.map ( s => {
          if ( s._id != this.currentStandings._id ) {
            return s;
          }

          return this.currentStandings;
        })
        */
        
        await this.refreshCurrentStandingsEntries();
 
        // Update session hashmap
        this.standingsHashmap = {};
        this.season.standings.forEach ( standings => {
          this.standingsHashmap[standings._id] = standings
        })
        
        this.selectStandings(this.currentStandings._id);
        this.editStandingsDialog = false;
        this.editStandingsEventsDialog = false;
      },
      removeDriverFromCurrentStandings(entryId, driverId) {
        this.currentStandings.entries = this.currentStandings.entries.map ( entry => {
          if ( entry._id != entryId ) {
            return entry;
          }
          
          entry.drivers = entry.drivers.filter ( d => d._id != driverId );
          
          return entry;
        });
        
        this.unsavedChanges = true
      },
      removeCarFromCurrentStandings(entryId, carId) {
        this.currentStandings.entries = this.currentStandings.entries.map ( entry => {
          if ( entry._id != entryId ) {
            return entry;
          }
          
          entry.cars = entry.cars.filter ( d => d._id != carId );
          
          return entry;
        });
        
        this.unsavedChanges = true
      },
      removeTeamFromCurrentStandings(entryId, teamId) {
        this.currentStandings.entries = this.currentStandings.entries.map ( entry => {
          if ( entry._id != entryId ) {
            return entry;
          }
          
          entry.teams = entry.teams.filter ( d => d._id != teamId );
          
          return entry;
        });
        
        this.unsavedChanges = true
      },
      async getFreshStandingsInfo ( entryId, request, options ) {
        let response = await axios.post (
          `/api/standings/${this.season._id}/fresh`,
          {
            drivers: options.drivers,
            cars: options.cars,
            request: request
          }
        )
        
        return response.data.data
      },
      async refreshEntryTeams( entryId, options ) {
        let newTeams = await this.getFreshStandingsInfo ( entryId, 'teams', options );
        
        this.currentStandings.entries = this.currentStandings.entries.map ( entry => {
          if ( entry._id != entryId ) {
            return entry;
          }
          
          entry.teams = newTeams;
          
          return entry;
        });
        
        this.unsavedChanges = true
        this.saveEditCurrentStandings();
      },
      async refreshEntryDrivers( entryId, options ) {
        let newDrivers = await this.getFreshStandingsInfo ( entryId, 'drivers', options );
        
        this.currentStandings.entries = this.currentStandings.entries.map ( entry => {
          if ( entry._id != entryId ) {
            return entry;
          }
          
          entry.drivers = newDrivers;
          
          return entry;
        });
        
        this.unsavedChanges = true
        this.saveEditCurrentStandings();
      },
      async refreshEntryCars( entryId, options ) {
        let newCars = await this.getFreshStandingsInfo ( entryId, 'cars', options );
        
        this.currentStandings.entries = this.currentStandings.entries.map ( entry => {
          if ( entry._id != entryId ) {
            return entry;
          }
          
          entry.cars = newCars;
          
          return entry;
        });
        
        this.unsavedChanges = true
        this.saveEditCurrentStandings();
      },
      removeEntryFromCurrentStandings (entryId) {
        this.currentStandings.entries = this.currentStandings.entries.filter ( entry => entry._id != entryId);
        
        this.unsavedChanges = true
        this.saveEditCurrentStandings();
      },
      async getNewStandingsEntries () {
        let response = await axios.post (
          `/api/standings/${this.season._id}/new-entries`,
          {
            drivers: this.currentStandings.entries.map ( e => e.drivers ).flat(),
            cars: this.currentStandings.entries.map ( e => e.cars ).flat(),
            typeCode: this.currentStandings.type.code,
            startPosition: (Math.max( ...this.currentStandings.entries.map(e => e.position) )+1)
          }
        )
        
        this.currentStandings.entries = this.currentStandings.entries.concat ( response.data.data )
        this.unsavedChanges = true
        this.saveEditCurrentStandings();
      },
      async saveStandings() {
        this.standingsSaveLoading = true;
        try {
          const currentStandingsIndex = this.season.standings.findIndex(standings => {
            return standings === this.currentStandings
              || (standings && this.currentStandings && standings._id == this.currentStandings._id);
          });

          await this.saveEditCurrentStandings();

          let response = await axios.post (
            `/api/standings/${this.season._id}/save`,
            {
              standings: this.season.standings
            }
          )

          this.season.standings = response.data.data;

          // Update some stuff to please this stupid view
          this.season.standings = this.season.standings.map(st => {
            st.events = st.events.map(ev => {
              this.resetStandingsEventSelection(ev);

              return ev;
            })
            return st;
          })
        
          // Update session hashmap
          this.standingsHashmap = {};
          this.season.standings.forEach ( standings => {
            this.standingsHashmap[standings._id] = standings
          })
        
          this.unsavedChanges = false;
          this.editEnabled = false;

          const savedCurrentStandings = currentStandingsIndex >= 0
            ? this.season.standings[currentStandingsIndex]
            : this.season.standings[0];
          const savedStandingsId = savedCurrentStandings
            ? savedCurrentStandings._id || ''
            : '';

          // Saving replaces standings documents and therefore their IDs. Wait for
          // the slide items to be replaced before selecting the new document.
          await this.$nextTick();
          this.selectStandings(savedStandingsId);

          this.showSnackbar({
            timeout: 7000,
            content: 'Clasamentul a fost salvat.',
            color: 'success',
            value: true
          });
        } catch (error) {
          this.showSnackbar({
            timeout: 10000,
            content: 'Clasamentul nu a putut fi salvat. Datele existente au fost păstrate.',
            color: 'error',
            value: true
          });
        } finally {
          this.standingsSaveLoading = false;
        }
      },
    carLiveryFileName (raceNumber) {
      const seasonPrefix = this.season.code ? `RLR_${this.season.code}` : 'RLR';
      return `${seasonPrefix}_${raceNumber}.png`;
    },

    carHasLiveryPreview (raceNumber) {
      return !!this.season.code && !this.carLiveryHidden[String(raceNumber)];
    },

    carLiveryPreviewURL (raceNumber) {
      const key = String(raceNumber);
      const displayedNumber = this.carLiveryFallbacks[key] ? '00' : raceNumber;
      return `/car_ico/${this.carLiveryFileName(displayedNumber)}?v=${this.season.carIconsVersion || 0}`;
    },

    handleCarLiveryError (raceNumber) {
      const key = String(raceNumber);
      if (!this.carLiveryFallbacks[key] && key !== '00') {
        this.$set(this.carLiveryFallbacks, key, true);
      } else {
        this.$set(this.carLiveryHidden, key, true);
      }
    },
    },  
    computed: {
      ...mapGetters('auth', ['userinfo', 'isLoggedIn']),
      ...mapState('season', ['season', 'carModelsList', 'validNumbersList', 'userSeasonClasses']),
      ...mapState('team', ['simulators']),
      ...mapGetters("user", ["userPermissions", "userRoles"]),
      isAdministrator () {
        return this.userRoles.some(role => role && role.name === 'Administrator');
      },
      rlrRatingSettingsValid () {
        return !this.rlrRatingSettings.enabled
          || this.rlrRatingSettings.roundSelection !== 'specific'
          || this.rlrRatingSettings.rounds.length > 0;
      },
      rlrRatingSimulator () {
        return this.season.rules && this.season.rules.simulator && this.season.rules.simulator._id
          ? this.season.rules.simulator
          : null;
      },
      rlrRatingPolicySummary () {
        const policy = this.rlrRatingSimulator && this.rlrRatingSimulator.rlrRatingPolicy || {};
        const participation = policy.participationMode === 'dynamic'
          ? 'Calcul dinamic, minimum 0, rotunjit la puncte întregi'
          : `Bonus fix +${Number(policy.fixedBonus) || 0} per pilot eligibil`;
        const kFactor = policy.provisionalKMode === 'standard'
          ? 'K 200 pentru toți'
          : 'K 400 în primele 5 curse';
        return `${participation} · ${kFactor}`;
      },
      rlrRatingDiagnosticsRoute () {
        return this.rlrRatingSimulator ? {
          path: '/rlr-rating',
          query: {diagnostics: '1', simulator: this.rlrRatingSimulator._id}
        } : '/rlr-rating';
      },
      rlrRatingSettingsDirty () {
        return this.serializedRlrRatingSettings(this.rlrRatingSettings)
          !== this.serializedRlrRatingSettings(this.savedRlrRatingSettings);
      },
      rlrRatingSelectedRoundNames () {
        const selected = this.rlrRatingSettings.rounds || [];
        return (this.season.events || [])
          .filter(event => selected.includes(event._id))
          .map(event => event.title);
      },
      rlrRatingScopeSummary () {
        if (!this.rlrRatingSettings.enabled) {
          return 'Sezonul nu influențează momentan RLR Rating.';
        }
        if (this.rlrRatingSettings.roundSelection === 'all') {
          return `Întregul sezon este Ranked: toate cele ${(this.season.events || []).length} etape sunt incluse.`;
        }
        const names = this.rlrRatingSelectedRoundNames;
        return names.length
          ? `${names.length} ${names.length === 1 ? 'etapă selectată' : 'etape selectate'}: ${names.join(', ')}.`
          : 'Nu a fost selectată nicio etapă.';
      },
      rlrRatingRemovesHistory () {
        const saved = this.savedRlrRatingSettings;
        const current = this.rlrRatingSettings;
        if (!saved.enabled) return false;
        if (!current.enabled) return true;
        if (saved.roundSelection === 'all' && current.roundSelection === 'specific') return true;
        if (saved.roundSelection !== 'specific' || current.roundSelection !== 'specific') return false;
        return (saved.rounds || []).some(round => !(current.rounds || []).includes(round));
      },
      seasonCodeValid () {
        return /^[A-Za-z0-9_-]+$/.test(this.seasonCode || '');
      },
      rulebookPdfStyle () {
        if (!this.pdfRulebookAspectRatio) {
          return {}
        }

        return {
          width: `min(100%, calc((100vh - 260px) * ${this.pdfRulebookAspectRatio}))`
        }
      },
      availableStandings () {
        if (!this.standingsReady) {
          return [];
        }

        const standings = Array.isArray(this.season.standings) ? this.season.standings : [];

        if (this.canUserEditStandings) {
          return standings;
        }
        
        return standings.filter ( s => s.public )
      },
      seasonRegistrationsCount () {
        return this.season.registrations.reduce ( (a, c) => { return a+c.cars.length }, 0 )
      },
      minRacesPerEvent () {
        return Math.min.apply (null, this.season.events.map(event => event.sessions.filter(s => s.type.code == 'R').length));
      },
      maxRacesPerEvent () {
        return Math.max.apply (null, this.season.events.map(event => event.sessions.filter(s => s.type.code == 'R').length));
      },
      minRaceLength () {
        return Math.min.apply (null,
          this.season.events.map(event => {
            return Math.min.apply(null, event.sessions.filter(s => s.type.code == 'R').map(s => s.durationMinutes));
          })
        );
      },
      maxRaceLength () {
        return Math.max.apply (null,
          this.season.events.map(event => {
            return Math.max.apply(null, event.sessions.filter(s => s.type.code == 'R').map(s => s.durationMinutes));
          })
        );
      },
      seasonStartDate () {
        return Math.min.apply(null, this.season.events.map ( event => { return Date.parse ( event.time ) } ) )
      },
      seasonEndDate () {
        return Math.max.apply(null, this.season.events.map ( event => { return Date.parse ( event.time ) } ) )
      },
      seasonElapsedPercent () {
        const totalEvents = this.season.events.length;
        const elapsedEvents = this.season.events.filter(e => Date.parse(e.time) < Date.now()).length;

        /*
        const totalTime = this.seasonEndDate - this.seasonStartDate;
        const elapsedTime = ( Date.now() - this.seasonStartDate );

        return Math.min(100, Math.max(0, elapsedTime/totalTime*100));
        */

       return (elapsedEvents/totalEvents * 100);
      },
      currentStandingsAvailableEvents() {
        if (!this.currentStandings || !this.availableStandingsEvents) {
          return [];
        }
        
        let available = this.availableStandingsEvents.filter(event => {
          let registered = this.currentStandings.events
            .map(cse=> cse.obj._id.toString())
            .includes(event._id)
          
          return !registered;
        })
        
        return available;
      },
      registrationsOpen() {
        return Date.parse(this.season.deadlines.registration) > Date.now();
      },
      canUserEditStandings () {
        if ( this.season && this.season.permissions && this.season.permissions.editStandings ) {
          return this.userPermissions.filter(perm => this.season.permissions.editStandings.includes(perm)).length;
        }
        
        return false;
      },
      isTeamStandings() {
        if (!this.currentStandings) {
          return true;
        }
        
        return this.currentStandings.type.code == 'T';
        
      },
      extraColumnName() {
        if (!this.currentStandings) {
          return 'Info';
        }
        
        return this.currentStandings.miscTextName;
      },
      tab: {
        set(tab) {
          const query = {
            ...this.$route.query,
            tab
          };

          if ( tab == 'standings' ) {
            this.selectStandings(this.selectedStandings || this.$route.query.activeStandings, false);
            query.activeStandings = this.selectedStandings;
          }

          this.$router.replace({
            query
          })
        },
        get() {
          if (this.$route.query.tab)
            return this.$route.query.tab
          return "info"
        }
      },
      activeStandings: {
        set(activeStandings) {
          this.selectStandings(activeStandings);
        },
        get() {
          if (this.selectedStandings) return this.selectedStandings;
          if (this.$route.query.activeStandings) return this.$route.query.activeStandings;
          return "";
        }
      },
    dragDriversChipOptions() {
      return {
        animation: 200,
        group: "group",
        disabled: false,
        ghostClass: "ghost",
        sort: true,
      };
    },
    },
    async mounted() {
      await Promise.all([
        this.getUserPermissions(),
        this.getUserRoles()
      ]);
      
      await this.getSeason(this.$route.params.id);
      this.seasonCode = this.season.code || '';
      this.savedSeasonCode = this.seasonCode;
      this.prequalDriverSubtitle = this.season.prequalDriverSubtitle || 'club';
      this.savedPrequalDriverSubtitle = this.prequalDriverSubtitle;
      if (this.season.rules && this.season.rules.licensePoints) {
        this.licensePointSettings = JSON.parse(JSON.stringify(this.season.rules.licensePoints));
      }
      if (this.season.rules && this.season.rules.rlrRating) {
        this.rlrRatingSettings = Object.assign(
          {enabled: false, roundSelection: 'all', rounds: []},
          JSON.parse(JSON.stringify(this.season.rules.rlrRating))
        );
        this.rlrRatingSettings.rounds = (this.rlrRatingSettings.rounds || []).map(round => round._id || round);
      }
      this.savedRlrRatingSettings = JSON.parse(JSON.stringify(this.rlrRatingSettings));
      await this.getSeasonStandings(this.$route.params.id);

      // Standings are loaded separately from the season. Prepare them before any
      // registration-related work so unrelated incomplete historical references
      // cannot prevent the standings table from rendering.
      this.season.standings = (this.season.standings || []).filter(Boolean).map(st => {
        st.events = (st.events || []).filter(ev => ev && ev.obj).map(ev => {
          this.resetStandingsEventSelection(ev);

          return ev;
        })
        return st;
      })

      this.season.standings.forEach ( standings => {
        this.standingsHashmap[standings._id] = standings
      })

      this.standingsReady = true;

      // Keep a valid selection ready even when entering the standings tab after
      // mount. A stale URL ID must never leave a visible menu with an empty table.
      this.selectStandings(
        this.$route.query.activeStandings,
        this.$route.query.tab == 'standings'
      );

      if ( this.canUserEditStandings ) {
        await this.getAvailableStandingsEvents();
        await this.getAvailableScoringTypes();
        await this.getAvailableStandingsTypes();
      }
      
      await this.getUserSeasonClasses(this.season._id)
      this.setUserRegisteredTeams()
      this.setCarsUserDriving()

      this.newStandings = JSON.parse(JSON.stringify(this.emptyStandings));
    }
  }
</script>

<style>
.rulebook-pdf {
  margin-right: auto;
  margin-left: auto;
}

.standings-admin-toolbar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 4px;
  padding-top: 4px;
  padding-bottom: 4px;
}

.standings-edit-switch {
  flex: 0 0 auto;
}

.standings-drop-rounds-cue {
  font-size: 0.8em;
  opacity: 0.8;
}

.standings-position {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
}

.standings-evolution {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  font-size: 0.7rem;
  font-weight: 700;
  line-height: 0.8rem;
}

.standings-evolution--up {
  color: #4caf50;
}

.standings-evolution--down {
  color: #f44336;
}

.standings-evolution-arrow {
  width: 0;
  height: 0;
  border-right: 5px solid transparent;
  border-left: 5px solid transparent;
}

.standings-evolution-arrow--up {
  border-bottom: 7px solid #4caf50;
}

.standings-evolution-arrow--down {
  border-top: 7px solid #f44336;
}

.standings-evolution-new {
  color: rgba(127, 127, 127, 0.95);
  font-size: 0.6rem;
}

.standings-evolution-neutral {
  color: rgba(127, 127, 127, 0.95);
  font-size: 0.85rem;
}

.standings-attendance {
  display: flex;
  flex-wrap: nowrap;
  gap: 2px;
  min-width: 120px;
}

.standings-attendance-round {
  display: inline-flex;
  flex-direction: column;
  flex: 1 1 0;
  align-items: center;
  min-width: 24px;
  white-space: nowrap;
}

.standings-attendance-status {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

.standings-attendance-points {
  font-size: 0.7rem;
  line-height: 1.1;
}

.standings-attendance-points--ignored {
  color: #f44336;
  text-decoration: line-through;
}

.v-card--reveal {
  bottom: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
}

.v-slide-group__prev {
  display: flex !important;
}

.v-slide-group:not(.v-slide-group--has-affixes) > .v-slide-group__next {
  display: flex !important;
}

/*-----------LUC 2026-------------*/
kbd.driver-class {
  display: inline-flex;
  align-items: center;
  justify-content: center;

  min-width: 40px;     /* makes all boxes same width */
  padding: 0 8px;

  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;

  line-height: 1;              /* FIX vertical centering */
  vertical-align: middle;      /* FIX inline alignment */
  height: 1.8em;               /* pixel-perfect vertical alignment in tables?*/

  /*border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.4);*/

  background-color: #000;  /* fallback */
  color: #fff;
  border-radius: 3px;
}

/*--------------LUC 2026------------*/
</style>
